import * as Rx from "rxjs"
import * as FS from "firebase/firestore"
import { collection, getAggregateFromServer, type QueryCompositeFilterConstraint, type QueryConstraint, QueryNonFilterConstraint, sum } from "firebase/firestore"
import { useCallback, useEffect, useMemo, useState } from "react"
import {
  followingUsersQuery,
  joiningSpacesQuery,
  liveViewersByUserQuery,
  liveCommentsByUserQuery,
  spaceMessagesByUserQuery,
  livePowerHistoriesByUserQuery,
  selectionsByUserQuery,
  selectionParticipantSearchByUserQuery,
  globalVoicesQuery,
  allItemDistributionsQuery,
} from "./collection-group-queries"
import {
  AdminDocument,
  AdminDocuments,
  AdminId,
  AdminInviteDocument,
  AdminInviteDocuments,
  AdminOperationDocument,
  AdminOperationDocuments,
  AllowedDomainDocument,
  AllowedDomainDocuments,
  AppConfigDocuments,
  AppConfigConversionRateDocumentBody,
  AppConfigRequirementDocumentBody,
  AppConfigTermsDocumentBody,
  FeatureFlagDocumentBody,
  BlockDocument,
  BlockDocuments,
  BrandDocument,
  BrandDocuments,
  BulkDeliveryMaster,
  BulkDeliveryMasterDocuments,
  BulkDeliveryMasterKind,
  BulkDeliveryMasterStatus,
  BulkDeliveryTargetChunk,
  BulkDeliveryTargetChunkDocuments,
  BulkDeliveryTargetChunkStatus,
  WelcomeDeliveryMaster,
  WelcomeDeliveryMasterDocuments,
  CallPushDocument,
  CallPushDocuments,
  CallPushId,
  CoinPackDocument,
  CoinPackDocuments,
  CoinTransactionDocument,
  CoinTransactionDocuments,
  DefaultLookDocument,
  DefaultLookDocuments,
  DefaultLookId,
  SoulDocument,
  SoulDocuments,
  SoulId,
  InitialLookDocument,
  InitialLookDocuments,
  DocumentSnapshotLike,
  FirestorePaths,
  SpaceThumbnailSettingDocument,
  SpaceThumbnailSettingDocuments,
  VrmAccountImageSettingDocument,
  VrmAccountImageSettingDocuments,
  FollowDocument,
  FollowDocuments,
  GlobalNgWordDocument,
  GlobalNgWordDocuments,
  GlobalNgWordId,
  InviteDocument,
  InviteDocuments,
  InviteKindFriend,
  InviteKindLiveViewerSpace,
  InviteKindSpace,
  InviteStatus,
  ItemDistributionDocument,
  ItemDistributionDocuments,
  ItemDistributionId,
  ItemDocument,
  ItemDocuments,
  ItemId,
  LiveCommentDeletionDocument,
  LiveCommentDeletionDocuments,
  LiveCommentDocument,
  LiveCommentDocuments,
  LiveFreeBoardDocument,
  LiveFreeBoardDocuments,
  LiveDocument,
  LiveDocuments,
  LiveGenreDocument,
  LiveGenreDocuments,
  LiveGenreId,
  LiveHistoryDocument,
  LiveHistoryDocuments,
  LiveId,
  LivePowerId,
  LivePowerDocument,
  LivePowerHistoryDocument,
  LivePowerHistoryDocuments,
  LivePowerSummaryDocument,
  LivePowerSummaryDocuments,
  LiveViewerDocumentBody,
  Mood,
  LiveViewerDocuments,
  Loading,
  LoadingOption,
  AppConfigMaintenanceDocumentBody,
  MaintenanceDocuments,
  MaintenanceScheduleEntry,
  MaintenanceScheduleEntryId,
  ManagedImageDocument,
  ManagedImageDocuments,
  ManagedImageId,
  ManagedImageUsageType,
  PersonalNotificationId,
  PowerDocument,
  Powers,
  PredefinedAliasDocument,
  PredefinedAliases,
  PredefinedAliasQualifierDocument,
  PredefinedAliasQualifiers,
  PredefinedNicknameDocument,
  PredefinedNicknames,
  PushDeviceDocument,
  PushDeviceDocuments,
  RecommendedUserDocument,
  RecommendedUserDocuments,
  SaleDocument,
  SaleDocuments,
  SaleId,
  SelectionDocument,
  SelectionDocuments,
  SelectionId,
  SelectionParticipantId,
  SelectionParticipantNominateDocument,
  SelectionParticipantNominateDocuments,
  SelectionParticipantNominateSelected,
  SelectionParticipantPseudoNominateDocument,
  SelectionParticipantPseudoNominateDocuments,
  SelectionSequenceDocument,
  SelectionSequenceDocuments,
  SelectionSequenceId,
  HomeBannerDocument,
  HomeBannerDocuments,
  HomeBannerId,
  HomeLivePinDocument,
  HomeLivePinDocuments,
  HomeLivePinId,
  HomePickupDocument,
  HomePickupDocuments,
  PinnedStoryUserDocument,
  PinnedStoryUserDocuments,
  PinnedStoryUserId,
  ShopBannerDocument,
  ShopBannerDocuments,
  ShopBannerId,
  ShopCustomTagDocument,
  ShopCustomTagDocuments,
  ShopCustomTagId,
  ShopTopCompositionDocumentIds,
  ShopTopCompositionFirstDocument,
  ShopTopCompositionFirstDocuments,
  ShopTopCompositionListDocument,
  ShopTopCompositionListDocuments,
  SpaceBackgroundDocument,
  SpaceBackgroundDocuments,
  SpaceBackgroundId,
  SpaceBGMDocument,
  SpaceBGMDocuments,
  SpaceBGMId,
  SpaceDocument,
  SpaceDocuments,
  SpaceKey,
  SpaceMessageDeletionDocument,
  SpaceMessageDeletionDocuments,
  SpaceMessageDocument,
  SpaceMessageDocuments,
  SpaceMessageId,
  SpaceUserDocument,
  SpaceUserDocuments,
  StampCardDocument,
  StampCardDocuments,
  StampCardId,
  StampLaneDocument,
  StampLaneDocuments,
  StampLaneId,
  StampLaneRewardDocument,
  StampLaneRewardDocuments,
  StampMissionDocument,
  StampMissionDocuments,
  StoryDocument,
  StoryDocuments,
  StoryTimelineDocument,
  StoryTimelineDocuments,
  SystemNotificationDocument,
  SystemNotificationDocuments,
  SystemNotificationId,
  SystemNotificationReadStatusDocument,
  SystemNotificationReadStatusDocuments,
  TopicSuggestionDocument,
  TopicSuggestions,
  UserActivityDocument,
  UserActivityDocuments,
  UserActivityKindSpaceUser,
  UserDeviceDocument,
  UserDeviceDocuments,
  UserDocument,
  UserDocuments,
  UserId,
  UserInventoryDocument,
  UserInventoryDocuments,
  UserVrmRegistrationDocument,
  UserVrmRegistrationDocuments,
  VrmNgItemDocument,
  VrmNgItemDocuments,
  UserPersonalNotification,
  UserPersonalNotificationDocuments,
  UserPrivateDocument,
  UserPrivateDocuments,
  UserPushSettingDocumentBody,
  UserSettingDocument,
  UserSettingDocuments,
  UserSpaceSettingDocumentBody,
  UserSystemNotificationCheckStatusDocument,
  UserSystemNotificationCheckStatusDocuments,
  ItemKind,
  SubscriptionPlanDocument,
  SubscriptionPlanDocuments,
  SubscriptionPlanId,
  SubscriptionProductDocument,
  SubscriptionProductDocuments,
  SubscriptionProductId,
  ViolationReportDocument,
  ViolationReportDocuments,
  ViolationReportId,
  ViolationReportStatus,
  UserStampCardStateDocument,
  UserStampCardStateDocuments,
  UserStampMissionProgressDocument,
  UserStampMissionProgressDocuments,
  UserStampMissionDailyProgressDocument,
  UserStampMissionDailyProgressDocuments,
  StampMissionId,
  UserStampRewardClaimDocument,
  UserStampRewardClaimDocuments,
  SubscriptionItemGrantMasterDocument,
  SubscriptionItemGrantMasterDocuments,
  SubscriptionItemGrantMasterId,
  SubscriptionHistoryDocument,
  SubscriptionHistoryDocuments,
  UserVoiceTimelineDocument,
  UserVoiceTimelineDocuments,
  UserFavoriteDocument,
  UserFavoriteDocuments,
  VoiceDocument,
  VoiceDocuments,
  VoiceReplyDocument,
  VoiceReplyDocuments,
  VoiceEmoteDocument,
  VoiceEmoteDocuments,
  VoiceReplyEmoteDocument,
  VoiceReplyEmoteDocuments,
  VoiceId,
  VoiceReplyId,
} from "popopo-msg"
import * as FirebaseAuth from "firebase/auth"
import { assertNever, chunk, nonNullable } from "popopo-lib-common"
import { useObservable } from "rxjs-hooks"
import { fromRef } from "./lib/firestore/fromRef"

export type PagePosition = {
  start?: string
  until?: string
  pageSize: number
}

export type PageResult<T> = {
  docs: T[]
  next?: string
  prev?: string
}

export class FirestoreAccess {
  /** `documentId() in` に指定できる値の上限 */
  private static readonly documentIdInLimit = 30

  private readonly _firestore: FS.Firestore

  constructor(firestore: FS.Firestore) {
    this._firestore = firestore
  }

  static handleAuthorityError<T>(e: Error, path: string, value: T): Promise<T> {
    if (e.name === "FirebaseError" && e.message.indexOf("evaluation error") !== -1) {
      console.warn(path, e)
      return Promise.resolve(value)
    }
    console.error(path, e, value)
    throw e
  }

  static handleAuthorityErrorAsNull(e: Error, path: string): Promise<null> {
    return FirestoreAccess.handleAuthorityError(e, path, null)
  }

  static handleAuthorityErrorAsEmpty(e: Error, path: string): Promise<[]> {
    return FirestoreAccess.handleAuthorityError(e, path, [])
  }

  async getAdmin(adminId: AdminId): Promise<AdminDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Admins.getDocPath(adminId)))
    return AdminDocuments.fromDocumentSnapshot(document)
  }

  async getPowers(constraints?: FS.QueryConstraint[]): Promise<PowerDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.Powers.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.Powers.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(Powers.fromDocumentSnapshot).filter((doc): doc is PowerDocument => doc !== null)
  }

  async getLiveGenres(constraints?: FS.QueryConstraint[]): Promise<LiveGenreDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.LiveGenres.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.LiveGenres.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(LiveGenreDocuments.fromDocumentSnapshot).filter((doc): doc is LiveGenreDocument => doc !== null)
  }

  async getSpaceUser(spaceKey: SpaceKey, userId: UserId): Promise<SpaceUserDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Spaces.SpaceUsers.getDocPath(spaceKey, userId)))
    return SpaceUserDocuments.fromDocumentSnapshot(document)
  }

  async getSpaceUsers(spaceKey: SpaceKey, constraints?: FS.QueryConstraint[]): Promise<SpaceUserDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.Spaces.SpaceUsers.getPath(spaceKey)), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.Spaces.SpaceUsers.getPath(spaceKey))
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(SpaceUserDocuments.fromDocumentSnapshot).filter((doc): doc is SpaceUserDocument => doc !== null)
  }

  async getSpaceMessages(spaceKey: SpaceKey, constraints?: FS.QueryConstraint[]): Promise<SpaceMessageDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.Spaces.SpaceMessages.getPath(spaceKey)), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.Spaces.SpaceMessages.getPath(spaceKey))
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(SpaceMessageDocuments.fromDocumentSnapshot).filter((doc): doc is SpaceMessageDocument => doc !== null)
  }

  async getSpaceMessageDeletions(spaceKey: SpaceKey): Promise<SpaceMessageDeletionDocument[]> {
    const collectionPath = FirestorePaths.Spaces.SpaceMessageDeletions.getPath(spaceKey)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(doc => SpaceMessageDeletionDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is SpaceMessageDeletionDocument => doc !== null)
  }

  async getSpaceBackgrounds(constraints?: FS.QueryConstraint[]): Promise<SpaceBackgroundDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.SpaceBackgrounds.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.SpaceBackgrounds.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(SpaceBackgroundDocuments.fromDocumentSnapshot).filter((doc): doc is SpaceBackgroundDocument => doc !== null)
  }

  async getSpaceBGMs(constraints?: FS.QueryConstraint[]): Promise<SpaceBGMDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.SpaceBgms.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.SpaceBgms.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(SpaceBGMDocuments.fromDocumentSnapshot).filter((doc): doc is SpaceBGMDocument => doc !== null)
  }

  async getUser(userId: UserId): Promise<UserDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Users.getDocPath(userId)))
    return UserDocuments.fromDocumentSnapshot(document)
  }

  /**
   * ユーザーをまとめて取得する。存在しないユーザーは結果に含まれない。
   */
  async getUsersByIds(userIds: UserId[]): Promise<UserDocument[]> {
    const documents: UserDocument[] = []
    for (const ids of chunk(userIds, FirestoreAccess.documentIdInLimit)) {
      const snapshot = await FS.getDocs(FS.query(
        FS.collection(this._firestore, FirestorePaths.Users.path),
        FS.where(FS.documentId(), "in", ids),
      ))
      documents.push(...snapshot.docs.map(UserDocuments.fromDocumentSnapshot).filter(nonNullable))
    }
    return documents
  }

  async getPushSetting(userId: UserId): Promise<UserPushSettingDocumentBody | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.PushSettings.getDocPath(userId)))
    if (document === null || !document.exists()) {
      return null
    }
    const data = document.data()
    if (data === undefined) {
      return null
    }
    return UserPushSettingDocumentBody.parse(data)
  }

  async getCallPush(callPushId: CallPushId): Promise<CallPushDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.CallPushes.getDocPath(callPushId)))
    return CallPushDocuments.fromDocumentSnapshot(document)
  }

  async getFollower(followee: UserId, follower: UserId): Promise<FollowDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Users.Followers.getDocPath(followee, follower)))
    return FollowDocuments.fromDocumentSnapshot(document)
  }

  async getLive(spaceKey: SpaceKey, liveId: LiveId): Promise<LiveDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Spaces.Lives.getDocPath(spaceKey, liveId)))
    return LiveDocuments.fromDocumentSnapshot(document)
  }

  async getSelection(spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): Promise<SelectionDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Spaces.Lives.Selections.getDocPath(spaceKey, liveId, selectionId)))
    return SelectionDocuments.fromDocumentSnapshot(document)
  }

  async getSelectionNominateById(spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, nominateId: SelectionParticipantId): Promise<SelectionParticipantNominateDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Spaces.Lives.Selections.SelectionNominates.getDocPath(spaceKey, liveId, selectionId, nominateId)))
    return SelectionParticipantNominateDocuments.fromDocumentSnapshot(document)
  }

  async getSelectionNominatesBySelected(spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, selected: SelectionParticipantNominateSelected): Promise<SelectionParticipantNominateDocument[]> {
    const collectionPath = FirestorePaths.Spaces.Lives.Selections.SelectionNominates.getPath(spaceKey, liveId, selectionId)
    const q = FS.query(FS.collection(this._firestore, collectionPath), FS.where("selected", "==", selected))
    const snapshot = await FS.getDocs(q)
    return snapshot.docs.map(SelectionParticipantNominateDocuments.fromDocumentSnapshot).filter((doc): doc is SelectionParticipantNominateDocument => doc !== null)
  }

  async getSpace(spaceKey: SpaceKey): Promise<SpaceDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Spaces.getDocPath(spaceKey)))
    return SpaceDocuments.fromDocumentSnapshot(document)
  }

  async getLivePowers(spaceKey: SpaceKey, liveId: LiveId): Promise<LivePowerDocument[]> {
    const collectionPath = FirestorePaths.Spaces.Lives.LivePowers.getPath(spaceKey, liveId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs
      .map(doc => {
        if (!doc.exists()) return null
        return doc.data() as LivePowerDocument
      })
      .filter((doc): doc is LivePowerDocument => doc !== null)
  }

  async getLiveComments(spaceKey: SpaceKey, liveId: LiveId): Promise<LiveCommentDocument[]> {
    const collectionPath = FirestorePaths.Spaces.Lives.LiveComments.getPath(spaceKey, liveId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(doc => LiveCommentDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LiveCommentDocument => doc !== null)
  }

  async getLiveCommentDeletions(spaceKey: SpaceKey, liveId: LiveId): Promise<LiveCommentDeletionDocument[]> {
    const collectionPath = FirestorePaths.Spaces.Lives.LiveCommentDeletions.getPath(spaceKey, liveId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(doc => LiveCommentDeletionDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LiveCommentDeletionDocument => doc !== null)
  }

  async getLiveFreeBoards(spaceKey: SpaceKey, liveId: LiveId): Promise<LiveFreeBoardDocument[]> {
    const collectionPath = FirestorePaths.Spaces.Lives.LiveFreeBoards.getPath(spaceKey, liveId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(doc => LiveFreeBoardDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LiveFreeBoardDocument => doc !== null)
  }

  async getLiveHistory(liveId: LiveId): Promise<LiveHistoryDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.LiveHistories.getDocPath(liveId)))
    return LiveHistoryDocuments.fromDocumentSnapshot(document)
  }

  async getLivePowerHistories(liveId: LiveId): Promise<LivePowerHistoryDocument[]> {
    const collectionPath = FirestorePaths.LiveHistories.LivePowerHistories.getPath(liveId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(doc => LivePowerHistoryDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LivePowerHistoryDocument => doc !== null)
  }

  async getLivePowerHistory(liveId: LiveId, powerId: LivePowerId): Promise<LivePowerHistoryDocument | null> {
    const docPath = FirestorePaths.LiveHistories.LivePowerHistories.getDocPath(liveId, powerId)
    const document = await FS.getDoc(FS.doc(this._firestore, docPath))
    return LivePowerHistoryDocuments.fromDocumentSnapshot(document)
  }

  async getLivePowerHistoriesBySender(liveId: LiveId, userId: UserId): Promise<LivePowerHistoryDocument[]> {
    const collectionPath = FirestorePaths.LiveHistories.LivePowerHistories.getPath(liveId)
    const query = FS.query(FS.collection(this._firestore, collectionPath), FS.where('user.id', '==', userId))
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(doc => LivePowerHistoryDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LivePowerHistoryDocument => doc !== null)
  }

  async getLivePowerHistoriesByBroadcaster(liveId: LiveId, userId: UserId): Promise<LivePowerHistoryDocument[]> {
    const collectionPath = FirestorePaths.LiveHistories.LivePowerHistories.getPath(liveId)
    const query = FS.query(FS.collection(this._firestore, collectionPath), FS.where('live.user_id', '==', userId))
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(doc => LivePowerHistoryDocuments.fromDocumentSnapshot(doc)).filter((doc): doc is LivePowerHistoryDocument => doc !== null)
  }

  async getUserSpaceSettings(userId: UserId): Promise<UserSpaceSettingDocumentBody[]> {
    const collectionPath = FirestorePaths.Users.UserSpaceSetting.getPath(userId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs
      .map(doc => {
        if (!doc.exists()) return null
        return doc.data() as UserSpaceSettingDocumentBody
      })
      .filter((doc): doc is UserSpaceSettingDocumentBody => doc !== null)
  }

  async getUserPrivate(userId: UserId): Promise<UserPrivateDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.UserPrivates.getDocPath(userId)))
    return UserPrivateDocuments.fromDocumentSnapshot(document)
  }

  /**
   * ユーザーの非公開情報をまとめて取得する。存在しないユーザーは結果に含まれない。
   */
  async getUserPrivatesByIds(userIds: UserId[]): Promise<UserPrivateDocument[]> {
    const documents: UserPrivateDocument[] = []
    for (const ids of chunk(userIds, FirestoreAccess.documentIdInLimit)) {
      const snapshot = await FS.getDocs(FS.query(
        FS.collection(this._firestore, FirestorePaths.UserPrivates.path),
        FS.where(FS.documentId(), "in", ids),
      ))
      documents.push(...snapshot.docs.map(UserPrivateDocuments.fromDocumentSnapshot).filter(nonNullable))
    }
    return documents
  }

  async getUserInventory(userId: UserId, itemId: ItemId): Promise<UserInventoryDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.UserPrivates.UserInventory.getDocPath(userId, itemId)))
    return UserInventoryDocuments.fromDocumentSnapshot(document)
  }

  async getUserSetting(userId: UserId, targetUserId: UserId): Promise<UserSettingDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.UserPrivates.UserSettings.getDocPath(userId, targetUserId)))
    return UserSettingDocuments.fromDocumentSnapshot(document)
  }

  async getUserActivities(userId: UserId, kind: UserActivityKindSpaceUser, constraints?: FS.QueryConstraint[]): Promise<UserActivityDocument[]> {
    const baseQuery = FS.collection(this._firestore, FirestorePaths.UserPrivates.UserActivities.getPath(userId))
    const query = constraints
      ? FS.query(baseQuery, FS.where("kind", "==", kind), ...constraints)
      : FS.query(baseQuery, FS.where("kind", "==", kind))
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(UserActivityDocuments.fromDocumentSnapshot).filter((doc): doc is UserActivityDocument => doc !== null)
  }

  async getCoinTransactions(userId: UserId): Promise<CoinTransactionDocument[]> {
    const collectionPath = FirestorePaths.UserPrivates.CoinTransactions.getPath(userId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(CoinTransactionDocuments.fromDocumentSnapshot).filter((doc): doc is CoinTransactionDocument => doc !== null)
  }

  async getUserStampCardState(userId: UserId, cardId: StampCardId): Promise<UserStampCardStateDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.UserPrivates.StampCardStates.getDocPath(userId, cardId)))
    return UserStampCardStateDocuments.fromDocumentSnapshot(document)
  }

  async getUserStampMissionDailyProgresses(userId: UserId, cardId: StampCardId, missionId: StampMissionId): Promise<UserStampMissionDailyProgressDocument[]> {
    const collectionPath = FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.StampMissionDailyProgresses.getPath(userId, cardId, missionId)
    const snapshot = await FS.getDocs(FS.collection(this._firestore, collectionPath))
    return snapshot.docs.map(UserStampMissionDailyProgressDocuments.fromDocumentSnapshot).filter((doc): doc is UserStampMissionDailyProgressDocument => doc !== null)
  }

  async getCallPushes(constraints?: FS.QueryConstraint[]): Promise<CallPushDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.CallPushes.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.CallPushes.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(CallPushDocuments.fromDocumentSnapshot).filter((doc): doc is CallPushDocument => doc !== null)
  }

  async getFollowers(constraints?: FS.QueryConstraint[]): Promise<FollowDocument[]> {
    const query = constraints
      ? FS.query(FS.collectionGroup(this._firestore, FirestorePaths.Users.Followers.path), ...constraints)
      : FS.collectionGroup(this._firestore, FirestorePaths.Users.Followers.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(FollowDocuments.fromDocumentSnapshot).filter((doc): doc is FollowDocument => doc !== null)
  }

  async getShopCustomTags(): Promise<ShopCustomTagDocument[]> {
    const query = FS.query(
      FS.collection(this._firestore, FirestorePaths.ShopCustomTags.path),
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      FS.orderBy("priority", "desc")
    )
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(ShopCustomTagDocuments.fromDocumentSnapshot).filter((doc): doc is ShopCustomTagDocument => doc !== null)
  }

  async getShopBanners(): Promise<ShopBannerDocument[]> {
    const query = FS.query(
      FS.collection(this._firestore, FirestorePaths.ShopBanners.path),
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      FS.orderBy("priority", "desc")
    )
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(ShopBannerDocuments.fromDocumentSnapshot).filter((doc): doc is ShopBannerDocument => doc !== null)
  }

  async getHomeBanners(): Promise<HomeBannerDocument[]> {
    const query = FS.query(
      FS.collection(this._firestore, FirestorePaths.HomeBanners.path),
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      FS.orderBy("priority", "desc")
    )
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(HomeBannerDocuments.fromDocumentSnapshot).filter((doc): doc is HomeBannerDocument => doc !== null)
  }

  async getSales(constraints?: FS.QueryConstraint[]): Promise<SaleDocument[]> {
    const query = constraints
      ? FS.query(FS.collection(this._firestore, FirestorePaths.Sales.path), ...constraints)
      : FS.collection(this._firestore, FirestorePaths.Sales.path)
    const snapshot = await FS.getDocs(query)
    return snapshot.docs.map(SaleDocuments.fromDocumentSnapshot).filter((doc): doc is SaleDocument => doc !== null)
  }

  async getItem(itemId: ItemId): Promise<ItemDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Items.getDocPath(itemId)))
    return ItemDocuments.fromDocumentSnapshot(document)
  }

  async getItemDistribution(itemId: ItemId, distributionId: ItemDistributionId): Promise<ItemDistributionDocument | null> {
    const document = await FS.getDoc(FS.doc(this._firestore, FirestorePaths.Items.Distributions.getDocPath(itemId, distributionId)))
    return ItemDistributionDocuments.fromDocumentSnapshot(document)
  }

  async addLiveEvent(spaceKey: SpaceKey, liveId: LiveId, userId: UserId, kind: "voice", value: number): Promise<FS.DocumentReference>
  async addLiveEvent(spaceKey: SpaceKey, liveId: LiveId, userId: UserId, kind: "voice-and-mood", value: number, mood: Mood): Promise<FS.DocumentReference>
  async addLiveEvent(spaceKey: SpaceKey, liveId: LiveId, userId: UserId, kind: "voice" | "voice-and-mood", value: number, mood?: Mood): Promise<FS.DocumentReference> {
    const data: Record<string, unknown> = {
      user_id: userId,
      space_key: spaceKey,
      live_id: liveId,
      kind: kind,
      value: value,
      created_at: FS.serverTimestamp(),
    }
    if (kind === "voice-and-mood") {
      data.mood = mood
    }
    return FS.addDoc(
      FS.collection(this._firestore, FirestorePaths.Spaces.Lives.LiveEvents.getPath(spaceKey, liveId)),
      data,
    )
  }

  async waitSpaceMessage<T>(spaceKey: SpaceKey, messageId: SpaceMessageId, block: (_: FS.DocumentSnapshot) => void | T): Promise<T> {
    const docRef = FS.doc(this._firestore, FirestorePaths.Spaces.SpaceMessages.getDocPath(spaceKey, messageId))
    return new Promise<T>((resolve, reject) => {
      const cancel = FS.onSnapshot(docRef, {
        next(e) {
          const result = block(e)
          if (result !== undefined) {
            cancel()
            resolve(result)
          }
        },
        error: (err) => {
          cancel()
          reject(err)
        },
      })
    })
  }
}

export function useAdmin(firestore: FS.Firestore, adminId: LoadingOption<AdminId>): LoadingOption<AdminDocument> {
  return useDocument(firestore, FirestorePaths.Admins.path, adminId, AdminDocuments.fromDocumentSnapshot)
}

export function useAdminsPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<AdminDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Admins.path, AdminDocuments.fromDocumentSnapshot, pagePosition)
}

export function useCountAdmins(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.Admins.path)
}

export function useAdminInvitesPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<AdminInviteDocument>> {
  return useCollectionPage(firestore, FirestorePaths.AdminInvites.path, AdminInviteDocuments.fromDocumentSnapshot, pagePosition)
}

export function useCountAdminInvites(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.AdminInvites.path)
}

export function useUsers(firestore: FS.Firestore, limit: number): Loading<UserDocument[]> {
  return useCollection(firestore, FirestorePaths.Users.path, UserDocuments.fromDocumentSnapshot, limit, [FS.orderBy("created_at", "desc")])
}

export function useUser(firestore: FS.Firestore, userId: UserId | "loading"): LoadingOption<UserDocument> {
  return useDocument(firestore, FirestorePaths.Users.path, userId, UserDocuments.fromDocumentSnapshot)
}

export function useCountUsers(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.Users.path)
}

export function useUsersPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<UserDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Users.path, UserDocuments.fromDocumentSnapshot, pagePosition)
}

export function useUserSpacePushSetting(firestore: FS.Firestore, userId: UserId, spaceKey: SpaceKey): LoadingOption<UserSpaceSettingDocumentBody> {
  return useDocument(firestore, FirestorePaths.Users.UserSpaceSetting.getPath(userId), spaceKey, (e) => {
    if (e === null) {
      return null
    }
    const data = e.data()
    if (data === undefined) {
      return null
    }
    return UserSpaceSettingDocumentBody.parse(data)
  })
}

export function useBlockingUsers(firestore: FS.Firestore, userId: UserId, limit: number): Loading<BlockDocument[]> {
  return useCollection(firestore, FirestorePaths.Users.BlockUsers.getPath(userId), BlockDocuments.fromDocumentSnapshot, limit)
}

export function useBlockingUsersPage(firestore: FS.Firestore, userId: UserId, pagePosition: PagePosition): Loading<PageResult<BlockDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Users.BlockUsers.getPath(userId), BlockDocuments.fromDocumentSnapshot, pagePosition)
}

export function useFollower(firestore: FS.Firestore, followee: UserId, follower: UserId): LoadingOption<FollowDocument> {
  return useDocument(firestore, FirestorePaths.Users.Followers.getPath(followee), follower, FollowDocuments.fromDocumentSnapshot)
}

export function useFollowers(firestore: FS.Firestore, userId: UserId, limit: number): Loading<FollowDocument[]> {
  return useCollection(firestore, FirestorePaths.Users.Followers.getPath(userId), FollowDocuments.fromDocumentSnapshot, limit)
}

export function useFollowersPage(firestore: FS.Firestore, userId: UserId, pagePosition: PagePosition): Loading<PageResult<FollowDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Users.Followers.getPath(userId), FollowDocuments.fromDocumentSnapshot, pagePosition)
}

export function useTotalCountFollowers(firestore: FS.Firestore, userId: UserId): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.Users.Followers.getPath(userId))
}

export function useFollowingUsers(firestore: FS.Firestore, userId: UserId, limit: number): Loading<(FollowDocument)[]> {
  const docs = useCollectionGroupFromQuery(followingUsersQuery(firestore, userId, limit), FirestorePaths.Users.Followers.path, FollowDocuments.fromDocumentSnapshot)
  if (docs === "loading") {
    return "loading"
  }
  return docs.map((doc) => {
    return { ...doc }
  })
}

export function useTotalCountFollowingUsers(firestore: FS.Firestore, userId: UserId): Loading<number> {
  const query = FS.query(
    FS.collectionGroup(firestore, FirestorePaths.Users.Followers.path),
    FS.where("user_id", "==", userId),
    FS.orderBy("created_at", "desc")
  )
  return useTotalCountFromQuery(query)
}

export function usePushDevices(firestore: FS.Firestore, userId: UserId, limit: number): Loading<PushDeviceDocument[]> {
  return useCollection(firestore, FirestorePaths.Users.PushDevices.getPath(userId), PushDeviceDocuments.fromDocumentSnapshot, limit)
}

export function useUserDevices(firestore: FS.Firestore, userId: UserId, limit?: number): Loading<UserDeviceDocument[]> {
  return useCollection(firestore, FirestorePaths.UserPrivates.UserDevices.getPath(userId), UserDeviceDocuments.fromDocumentSnapshot, limit, [FS.orderBy("last_active_at", "desc")])
}

export function useUserVrmRegistrations(firestore: FS.Firestore, userId: UserId, limit?: number): Loading<UserVrmRegistrationDocument[]> {
  return useCollection(firestore, FirestorePaths.Users.VrmRegistrations.getPath(userId), UserVrmRegistrationDocuments.fromDocumentSnapshot, limit, [FS.orderBy("registered_at", "desc")])
}

export function useVrmNgItems(firestore: FS.Firestore, limit?: number): Loading<VrmNgItemDocument[]> {
  return useCollection(firestore, FirestorePaths.VrmNgItems.path, VrmNgItemDocuments.fromDocumentSnapshot, limit, [FS.orderBy("created_at", "desc")])
}


export function usePushSettings(firestore: FS.Firestore, userId: UserId): LoadingOption<UserPushSettingDocumentBody> {
  return useDocument(firestore, FirestorePaths.PushSettings.path, userId, (e) => {
    if (e === null) {
      return null
    }
    const data = e.data()
    if (data === undefined) {
      return null
    }
    return {
      ...data
    } as UserPushSettingDocumentBody
  })
}

export function usePredefinedNicknames(firestore: FS.Firestore): Loading<PredefinedNicknameDocument[]> {
  return useCollection(firestore, FirestorePaths.PredefinedNicknames.path, PredefinedNicknames.fromDocumentSnapshot, undefined, [FS.orderBy("value")])
}

export function usePredefinedAliases(firestore: FS.Firestore): Loading<PredefinedAliasDocument[]> {
  return useCollection(firestore, FirestorePaths.PredefinedAliases.path, PredefinedAliases.fromDocumentSnapshot, undefined, [FS.orderBy("value")])
}

export function usePredefinedAliasQualifiers(firestore: FS.Firestore): Loading<PredefinedAliasQualifierDocument[]> {
  return useCollection(firestore, FirestorePaths.PredefinedAliasesQualifiers.path, PredefinedAliasQualifiers.fromDocumentSnapshot, undefined, [FS.orderBy("value")])
}

export function useCoinPacks(firestore: FS.Firestore): Loading<CoinPackDocument[]> {
  return useCollection(firestore, FirestorePaths.CoinPacks.path, CoinPackDocuments.fromDocumentSnapshot)
}

export function useSpaces(firestore: FS.Firestore, limit: number): Loading<SpaceDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.path, SpaceDocuments.fromDocumentSnapshot, limit)
}

export function useSpaceBackground(firestore: FS.Firestore, spaceBackgroundId: SpaceBackgroundId): LoadingOption<SpaceBackgroundDocument> {
  return useDocument(firestore, FirestorePaths.SpaceBackgrounds.path, spaceBackgroundId, SpaceBackgroundDocuments.fromDocumentSnapshot)
}

export function useSpaceBackgroundsForAdmin(firestore: FS.Firestore): Loading<SpaceBackgroundDocument[]> {
  return useCollection(firestore, FirestorePaths.SpaceBackgrounds.path, SpaceBackgroundDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("priority", "desc")])
}

export function useSpaceBackgroundsByRecommendSpaceBGMId(firestore: FS.Firestore, spaceBGMId: SpaceBGMId): Loading<SpaceBackgroundDocument[]> {
  return useCollection(firestore, FirestorePaths.SpaceBackgrounds.path, SpaceBackgroundDocuments.fromDocumentSnapshot, undefined, [FS.where("recommend_bgm", "==", spaceBGMId)])
}

export function usePublicSpaceBackgroundsForAdmin(firestore: FS.Firestore): Loading<SpaceBackgroundDocument[]> {
  const result = useCollection(firestore, FirestorePaths.SpaceBackgrounds.path, SpaceBackgroundDocuments.fromDocumentSnapshot, undefined, [FS.where("status", "==", "public")])
  return result === "loading" ? "loading" : result.sort((a, b) => b.priority - a.priority)
}

export function useSpacesPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<SpaceDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Spaces.path, SpaceDocuments.fromDocumentSnapshot, pagePosition)
}

export function useSpacesCount(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.Spaces.path)
}

export function useMySpaces(firestore: FS.Firestore, userId: UserId, limit: number): Loading<SpaceDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.path, SpaceDocuments.fromDocumentSnapshot, limit, [FS.where("user_id", "==", userId)])
}

export function useJoiningSpaces(firestore: FS.Firestore, userId: UserId, limit: number): Loading<(SpaceUserDocument & { spaceKey: SpaceKey })[]> {
  const spaceUsers = useCollectionGroupFromQuery(joiningSpacesQuery(firestore, userId, limit), FirestorePaths.Spaces.SpaceUsers.path, SpaceUserDocuments.fromDocumentSnapshot)
  if (spaceUsers === "loading") {
    return "loading"
  }
  return spaceUsers.map((x) => {
    return { ...x, spaceKey: SpaceKey(x._path[1]) }
  })
}

export function useSpaceBGM(firestore: FS.Firestore, spaceBGMId: SpaceBGMId): LoadingOption<SpaceBGMDocument> {
  return useDocument(firestore, FirestorePaths.SpaceBgms.path, spaceBGMId, SpaceBGMDocuments.fromDocumentSnapshot)
}

export function useSpaceBGMsForAdmin(firestore: FS.Firestore): Loading<SpaceBGMDocument[]> {
  return useCollection(firestore, FirestorePaths.SpaceBgms.path, SpaceBGMDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("priority", "desc")])
}

export function usePublicSpaceBGMsForAdmin(firestore: FS.Firestore): Loading<SpaceBGMDocument[]> {
  const result = useCollection(firestore, FirestorePaths.SpaceBgms.path, SpaceBGMDocuments.fromDocumentSnapshot, undefined, [FS.where("status", "==", "public")])
  return result === "loading" ? "loading" : result.sort((a, b) => b.priority - a.priority)
}

export function useSpace(firestore: FS.Firestore, spaceKey: SpaceKey): LoadingOption<SpaceDocument> {
  return useDocument(firestore, FirestorePaths.Spaces.path, spaceKey, SpaceDocuments.fromDocumentSnapshot)
}

export function useSpaceUser(firestore: FS.Firestore, spaceKey: SpaceKey, userId: UserId): LoadingOption<SpaceUserDocument> {
  return useDocument(firestore, FirestorePaths.Spaces.SpaceUsers.getPath(spaceKey), userId, SpaceUserDocuments.fromDocumentSnapshot)
}

export function useSpaceUsers(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<SpaceUserDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.SpaceUsers.getPath(spaceKey), SpaceUserDocuments.fromDocumentSnapshot)
}

export function useFollow(firestore: FS.Firestore, followee: UserId, follower: UserId): LoadingOption<FollowDocument> {
  return useDocument(firestore, FirestorePaths.Users.Followers.getPath(followee), follower, FollowDocuments.fromDocumentSnapshot)
}

export function useGlobalNgWordsPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<GlobalNgWordDocument>> {
  return useCollectionPage(firestore, FirestorePaths.GlobalNgWords.path, GlobalNgWordDocuments.fromDocumentSnapshot, pagePosition)
}

export function useCountGlobalNgWords(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.GlobalNgWords.path)
}

export function useAllowedDomains(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<AllowedDomainDocument>> {
  return useCollectionPage(firestore, FirestorePaths.AllowedDomains.path, AllowedDomainDocuments.fromDocumentSnapshot, pagePosition, { ordering: { field: "domain", direction: "asc" } })
}

export function useRecommendedUsers(firestore: FS.Firestore): Loading<RecommendedUserDocument[]> {
  return useCollection(firestore, FirestorePaths.RecommendedUsers.path, RecommendedUserDocuments.fromDocumentSnapshot)
}

export function useAppConfigRequirement(firestore: FS.Firestore): LoadingOption<AppConfigRequirementDocumentBody> {
  return useDocument(firestore, FirestorePaths.AppConfigs.path, AppConfigDocuments.requirementId, (x) => (x === null ? null : (x.data() as AppConfigRequirementDocumentBody)))
}

export function useAppConfigTerms(firestore: FS.Firestore): LoadingOption<AppConfigTermsDocumentBody> {
  return useDocument(firestore, FirestorePaths.AppConfigs.path, AppConfigDocuments.termsId, (x) => (x === null ? null : (x.data() as AppConfigTermsDocumentBody)))
}

export function useAppConfigConversionRate(firestore: FS.Firestore): LoadingOption<AppConfigConversionRateDocumentBody> {
  return useDocument(firestore, FirestorePaths.AppConfigs.path, AppConfigDocuments.conversionRateId, (x) => (x === null ? null : (x.data() as AppConfigConversionRateDocumentBody)))
}

export type FeatureFlagListEntry = FeatureFlagDocumentBody & { id: string }

export function useFeatureFlags(firestore: FS.Firestore): Loading<FeatureFlagListEntry[]> {
  return useCollection(firestore, FirestorePaths.FeatureFlags.path, (doc) => ({ id: doc.id, ...(doc.data() as FeatureFlagDocumentBody) }))
}

export function useFeatureFlag(firestore: FS.Firestore, flagId: string): LoadingOption<FeatureFlagDocumentBody> {
  return useDocument(firestore, FirestorePaths.FeatureFlags.path, flagId, (x) => (x === null ? null : (x.data() as FeatureFlagDocumentBody)))
}

export function useSpaceThumbnailSetting(firestore: FS.Firestore): LoadingOption<SpaceThumbnailSettingDocument> {
  return useDocument(firestore, FirestorePaths.Systems.path, SpaceThumbnailSettingDocuments.SPACE_THUMBNAIL_SETTING_ID, SpaceThumbnailSettingDocuments.fromDocumentSnapshot)
}

export function useVrmAccountImageSetting(firestore: FS.Firestore): LoadingOption<VrmAccountImageSettingDocument> {
  return useDocument(firestore, FirestorePaths.Systems.path, VrmAccountImageSettingDocuments.VRM_ACCOUNT_IMAGE_SETTING_ID, VrmAccountImageSettingDocuments.fromDocumentSnapshot)
}

export function usePowers(firestore: FS.Firestore): Loading<PowerDocument[]> {
  return useCollection(firestore, FirestorePaths.Powers.path, Powers.fromDocumentSnapshot)
}

export function useItems(firestore: FS.Firestore): Loading<ItemDocument[]> {
  return useCollection(firestore, FirestorePaths.Items.path, ItemDocuments.fromDocumentSnapshot)
}

export async function fetchItems(firestore: FS.Firestore): Promise<ItemDocument[]> {
  const snapshot = await FS.getDocs(FS.collection(firestore, FirestorePaths.Items.path))
  return snapshot.docs.map(ItemDocuments.fromDocumentSnapshot).filter(nonNullable)
}

export function useItemsByIds(firestore: FS.Firestore, ids: ItemId[]): Loading<ItemDocument[]> {
  const [result, setResult] = useState<Loading<ItemDocument[]>>("loading")
  const idsKey = ids.join(",")

  useEffect(() => {
    const effectIds = idsKey.length === 0 ? [] : idsKey.split(",") as ItemId[]
    if (effectIds.length === 0) {
      setResult([])
      return
    }

    setResult("loading")
    let aborted = false

    void (async () => {
      try {
        const chunks: ItemId[][] = []
        for (let i = 0; i < effectIds.length; i += 30) {
          chunks.push(effectIds.slice(i, i + 30))
        }

        const allResults: ItemDocument[] = []
        for (const chunk of chunks) {
          const q = FS.query(
            FS.collection(firestore, FirestorePaths.Items.path),
            FS.where(FS.documentId(), "in", chunk),
          )
          const snapshot = await FS.getDocs(q)
          const docs = snapshot.docs.map(ItemDocuments.fromDocumentSnapshot).filter(nonNullable)
          allResults.push(...docs)
        }

        if (!aborted) {
          setResult(allResults)
        }
      } catch (e) {
        await FirestoreAccess.handleAuthorityErrorAsEmpty(e as Error, FirestorePaths.Items.path)
        if (!aborted) {
          setResult([])
        }
      }
    })()

    return () => { aborted = true }
  }, [firestore, idsKey])

  return result
}

export function usePublicItems(firestore: FS.Firestore): Loading<ItemDocument[]> {
  return useCollection(firestore, FirestorePaths.Items.path, ItemDocuments.fromDocumentSnapshot, undefined, [
    FS.where("status", "==", "public"),
    FS.orderBy("updated_at", "desc"),
  ])
}

export function usePublicItemsByPrefixPage(
  firestore: FS.Firestore,
  namePrefix: string | null,
  kind: ItemKind | "all",
  pagePosition: PagePosition,
): Loading<PageResult<ItemDocument>> {
  const baseQuery = useMemo(() => {
    const constraints: FS.QueryConstraint[] = []

    constraints.push(FS.where("status", "==", "public"))

    if (kind !== "all") {
      constraints.push(FS.where("kind", "==", kind))
    }

    if (namePrefix && namePrefix.trim() !== "") {
      const prefix = namePrefix.trim()
      const prefixEnd = `${prefix}\uf8ff`
      constraints.push(
        FS.where("name", ">=", prefix),
        FS.where("name", "<=", prefixEnd),
        FS.orderBy("name", "asc"),
      )
    } else {
      constraints.push(FS.orderBy("updated_at", "desc"))
    }

    return FS.query(FS.collection(firestore, FirestorePaths.Items.path), ...constraints)
  }, [firestore, namePrefix, kind])

  const getPivotDocRef = useCallback(
    (docId: string) => FS.doc(firestore, `${FirestorePaths.Items.path}/${docId}`),
    [firestore],
  )

  const converter = useCallback(
    (doc: DocumentSnapshotLike) => ItemDocuments.fromDocumentSnapshot(doc),
    [],
  )

  return useQueryPage(baseQuery, getPivotDocRef, converter, pagePosition)
}

export function useItem(firestore: FS.Firestore, id: ItemId): LoadingOption<ItemDocument> {
  return useDocument(firestore, FirestorePaths.Items.path, id, ItemDocuments.fromDocumentSnapshot)
}

export function useItemDistribution(firestore: FS.Firestore, itemId: ItemId, id: ItemDistributionId): LoadingOption<ItemDistributionDocument> {
  return useDocument(firestore, FirestorePaths.Items.Distributions.getPath(itemId), id, ItemDistributionDocuments.fromDocumentSnapshot)
}

export function useItemDistributions(firestore: FS.Firestore, itemId: ItemId): Loading<ItemDistributionDocument[]> {
  return useCollection(firestore, FirestorePaths.Items.Distributions.getPath(itemId), ItemDistributionDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("created_at", "desc")])
}

export function usePublicItemDistributions(firestore: FS.Firestore, itemId: ItemId): Loading<ItemDistributionDocument[]> {
  return useCollection(firestore, FirestorePaths.Items.Distributions.getPath(itemId), ItemDistributionDocuments.fromDocumentSnapshot, undefined, [
    FS.where("status", "==", "public"),
    FS.where("sale_period_state.active", "==", true),
    FS.orderBy("start_at", "desc"),
  ])
}

export type ItemDistributionWithPath = ItemDistributionDocument & { _path: string[]; itemId: ItemId }

export function useRecommendedItemDistributions(firestore: FS.Firestore): Loading<ItemDistributionWithPath[]> {
  const query = FS.query(FS.collectionGroup(firestore, FirestorePaths.Items.Distributions.path), FS.where("is_recommended", "==", true))
  const result = useCollectionGroupFromQuery(query, FirestorePaths.Items.Distributions.path, ItemDistributionDocuments.fromDocumentSnapshot)
  if (result === "loading") {
    return "loading"
  }
  return result.map((doc) => ({
    ...doc,
    itemId: doc._path[1] as ItemId,
  }))
}

export function useAllItemDistributionsForAdmin(
  firestore: FS.Firestore
): Loading<ItemDistributionWithPath[]> {
  // Note: orderByを使用するとFirestoreコレクショングループインデックスが必要になるため、
  // ソートはクライアント側のSortableDataTableで行う
  const result = useCollectionGroupFromQuery(allItemDistributionsQuery(firestore), FirestorePaths.Items.Distributions.path, ItemDistributionDocuments.fromDocumentSnapshot)
  if (result === "loading") {
    return "loading"
  }
  return result.map((doc) => ({
    ...doc,
    itemId: doc._path[1] as ItemId,
  }))
}

export async function fetchAllItemDistributionsForAdmin(
  firestore: FS.Firestore
): Promise<ItemDistributionWithPath[]> {
  const snapshot = await FS.getDocs(allItemDistributionsQuery(firestore))
  return snapshot.docs
    .map((doc) => {
      const value = ItemDistributionDocuments.fromDocumentSnapshot(doc)
      if (!value) return null
      return { ...value, _path: doc.ref.path.split("/"), itemId: doc.ref.path.split("/")[1] as ItemId }
    })
    .filter(nonNullable)
}

export function useBrands(firestore: FS.Firestore): Loading<BrandDocument[]> {
  return useCollection(firestore, FirestorePaths.Brands.path, BrandDocuments.fromDocumentSnapshot)
}

export function useGlobalNgWord(firestore: FS.Firestore, id: GlobalNgWordId): LoadingOption<GlobalNgWordDocument> {
  return useDocument(firestore, FirestorePaths.GlobalNgWords.path, id, GlobalNgWordDocuments.fromDocumentSnapshot)
}

export function useDefaultLooks(firestore: FS.Firestore): Loading<DefaultLookDocument[]> {
  return useCollection(firestore, FirestorePaths.DefaultLooks.path, DefaultLookDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("display_order", "desc")])
}

export function useDefaultLook(firestore: FS.Firestore, id: DefaultLookId): LoadingOption<DefaultLookDocument> {
  return useDocument(firestore, FirestorePaths.DefaultLooks.path, id, DefaultLookDocuments.fromDocumentSnapshot)
}

export function useSouls(firestore: FS.Firestore): Loading<SoulDocument[]> {
  return useCollection(firestore, FirestorePaths.Souls.path, SoulDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("priority", "desc")])
}

export function useSoul(firestore: FS.Firestore, id: SoulId): LoadingOption<SoulDocument> {
  return useDocument(firestore, FirestorePaths.Souls.path, id, SoulDocuments.fromDocumentSnapshot)
}

export function useInitialLooks(firestore: FS.Firestore): Loading<InitialLookDocument[]> {
  return useCollection(firestore, FirestorePaths.InitialLooks.path, InitialLookDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("priority", "desc")])
}

export function usePublicInitialLooks(firestore: FS.Firestore): Loading<InitialLookDocument[]> {
  return useCollection(firestore, FirestorePaths.InitialLooks.path, InitialLookDocuments.fromDocumentSnapshot, undefined, [FS.where("status", "==", "public"), FS.orderBy("priority", "desc")])
}

export function useInitialLook(firestore: FS.Firestore, itemId: ItemId): LoadingOption<InitialLookDocument> {
  return useDocument(firestore, FirestorePaths.InitialLooks.path, itemId, InitialLookDocuments.fromDocumentSnapshot)
}

export function useLatestFriendInvite(firestore: FS.Firestore, userId: UserId): LoadingOption<InviteDocument> {
  const result = useCollection(
    firestore,
    FirestorePaths.Invites.path,
    InviteDocuments.fromDocumentSnapshot,
    1,
    [
      FS.where("kind", "==", InviteKindFriend.value),
      FS.where("user_id", "==", userId),
      FS.orderBy("created_at", "desc"),
    ]
  )
  return result === "loading" ? "loading" : 0 < result.length ? result[0] : null
}

export function useUserInventories(firestore: FS.Firestore, userId: UserId): Loading<UserInventoryDocument[]> {
  return useCollection(firestore, FirestorePaths.UserPrivates.UserInventory.getPath(userId), UserInventoryDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("created_at", "desc")])
}

export function useLivePowerHistoriesByUser(firestore: FS.Firestore, userId: UserId): Loading<LivePowerHistoryDocument[]> {
  const docs = useCollectionGroupFromQuery(livePowerHistoriesByUserQuery(firestore, userId), FirestorePaths.LiveHistories.LivePowerHistories.path, LivePowerHistoryDocuments.fromDocumentSnapshot)
  if (docs === "loading") {
    return "loading"
  }
  return docs.map((doc) => {
    return { ...doc }
  })
}

export function useLiveHistory(firestore: FS.Firestore, liveId: LiveId): LoadingOption<LiveHistoryDocument> {
  return useDocument(firestore, FirestorePaths.LiveHistories.path, liveId, LiveHistoryDocuments.fromDocumentSnapshot)
}

export function useLiveHistoriesByParticipant(firestore: FS.Firestore, userId: UserId): Loading<LiveHistoryDocument[]> {
  return useCollection(firestore, FirestorePaths.LiveHistories.path, LiveHistoryDocuments.fromDocumentSnapshot, undefined, [FS.where("users", "array-contains", userId), FS.orderBy("stopped_at", "desc")])
}

export function useLiveViewersByUser(firestore: FS.Firestore, userId: UserId): Loading<(LiveViewerDocumentBody & { _path: string[] })[]> {
  return useCollectionGroupFromQuery(liveViewersByUserQuery(firestore, userId), FirestorePaths.Spaces.Lives.LiveViewers.path, LiveViewerDocuments.fromDocumentSnapshot)
}

export function useLiveCommentsByUser(firestore: FS.Firestore, userId: UserId): Loading<(LiveCommentDocument & { _path: string[] })[]> {
  return useCollectionGroupFromQuery(liveCommentsByUserQuery(firestore, userId), FirestorePaths.Spaces.Lives.LiveComments.path, LiveCommentDocuments.fromDocumentSnapshot)
}

export function useSpaceMessagesByUser(firestore: FS.Firestore, userId: UserId): Loading<(SpaceMessageDocument & { _path: string[] })[]> {
  return useCollectionGroupFromQuery(spaceMessagesByUserQuery(firestore, userId), FirestorePaths.Spaces.SpaceMessages.path, SpaceMessageDocuments.fromDocumentSnapshot)
}

export function useSelectionsByUser(firestore: FS.Firestore, userId: UserId): Loading<(SelectionDocument & { _path: string[] })[]> {
  return useCollectionGroupFromQuery(selectionsByUserQuery(firestore, userId), FirestorePaths.Spaces.Lives.Selections.path, SelectionDocuments.fromDocumentSnapshot)
}

export function useLatestSpaceInvite(firestore: FS.Firestore, spaceKey: SpaceKey): LoadingOption<InviteDocument> {
  const result = useCollection(
    firestore,
    FirestorePaths.Invites.path,
    InviteDocuments.fromDocumentSnapshot,
    1,
    [
      FS.where("kind", "==", InviteKindSpace.value),
      FS.where("space_key", "==", spaceKey),
      FS.orderBy("created_at", "desc"),
    ]
  )
  return result === "loading" ? "loading" : 0 < result.length ? result[0] : null
}

export function useLiveViewerSpaceInvitesByTargetUser(firestore: FS.Firestore, targetUserId: UserId, status: InviteStatus): Loading<InviteDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Invites.path,
    InviteDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.where("kind", "==", InviteKindLiveViewerSpace.value),
      FS.where("target_user_id", "==", targetUserId),
      FS.where("status", "==", status),
      FS.orderBy("created_at", "desc"),
    ]
  )
}

export function useLiveGenres(firestore: FS.Firestore): Loading<LiveGenreDocument[]> {
  return useCollection(firestore, FirestorePaths.LiveGenres.path, LiveGenreDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("priority", "desc")])
}

export function useLiveGenre(firestore: FS.Firestore, id: LiveGenreId): LoadingOption<LiveGenreDocument> {
  return useDocument(firestore, FirestorePaths.LiveGenres.path, id, LiveGenreDocuments.fromDocumentSnapshot)
}

export function useLiveSpaces(firestore: FS.Firestore, limit: number): Loading<SpaceDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.path, SpaceDocuments.fromDocumentSnapshot, limit, [FS.where("live_id", "!=", null)])
}

export function useSpaceMessages(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<SpaceMessageDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.SpaceMessages.getPath(spaceKey),
    SpaceMessageDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

/**
 * スペースメッセージの削除イベントを購読する。
 * クライアントは購読範囲外のメッセージ削除を検知するためにこのフックを使用する。
 */
export function useSpaceMessageDeletions(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<SpaceMessageDeletionDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.SpaceMessageDeletions.getPath(spaceKey),
    SpaceMessageDeletionDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useLives(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<LiveDocument[]> {
  return useCollection(firestore,
    FirestorePaths.Spaces.Lives.getPath(spaceKey),
    LiveDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useLivesPage(firestore: FS.Firestore, spaceKey: SpaceKey, pagePosition: PagePosition): Loading<PageResult<LiveDocument>> {
  return useCollectionPage(firestore, FirestorePaths.Spaces.Lives.getPath(spaceKey), LiveDocuments.fromDocumentSnapshot, pagePosition)
}

export function useLivesCount(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.Spaces.Lives.getPath(spaceKey))
}

export function useLive(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId): LoadingOption<LiveDocument> {
  return useDocument(firestore, FirestorePaths.Spaces.Lives.getPath(spaceKey), liveId, LiveDocuments.fromDocumentSnapshot)
}

export function useLivePowerSummaries(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, limit?: number): Loading<LivePowerSummaryDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.Lives.LivePowerSummaries.getPath(spaceKey, liveId), LivePowerSummaryDocuments.fromDocumentSnapshot, limit, [FS.orderBy("total_price", "desc")])
}

export function writeLiveVoiceEvent(firestore: FS.Firestore, user: FirebaseAuth.User, spaceKey: SpaceKey, liveId: LiveId) {
  return FS.addDoc(FS.collection(firestore, FirestorePaths.Spaces.Lives.LiveEvents.getPath(spaceKey, liveId)), {
    user_id: user.uid,
    space_key: spaceKey,
    live_id: liveId,
    kind: "voice",
    value: Math.trunc(Math.random() * 100),
    created_at: FS.serverTimestamp(),
  })
}

export function createLiveAccessLog(
  firestore: FS.Firestore,
  user: FirebaseAuth.User,
  spaceKey: SpaceKey,
  liveId: LiveId,
) {
  return Promise.all([
    FS.setDoc(FS.doc(firestore, FirestorePaths.Spaces.Lives.LiveViewers.getDocPath(spaceKey, liveId, user.uid as UserId)), {
      user_id: user.uid,
      space_key: spaceKey,
      live_id: liveId,
      new_user_live_comment_id: null,
      updated_at: FS.serverTimestamp(),
      created_at: FS.serverTimestamp(),
    }),

    FS.addDoc(FS.collection(firestore, FirestorePaths.Spaces.Lives.LiveViewers.LiveViewLogs.getPath(spaceKey, liveId, user.uid as UserId)), {
      user_id: user.uid,
      space_key: spaceKey,
      live_id: liveId,
      created_at: FS.serverTimestamp(),
    }),
  ])
}

export function updateLiveAccessLog(
  firestore: FS.Firestore,
  user: FirebaseAuth.User,
  spaceKey: SpaceKey,
  liveId: LiveId,
) {
  return Promise.all([
    FS.updateDoc(FS.doc(firestore, FirestorePaths.Spaces.Lives.LiveViewers.getDocPath(spaceKey, liveId, user.uid as UserId)), {
      updated_at: FS.serverTimestamp(),
      left_at: null,
    }),

    FS.addDoc(FS.collection(firestore, FirestorePaths.Spaces.Lives.LiveViewers.LiveViewLogs.getPath(spaceKey, liveId, user.uid as UserId)), {
      user_id: user.uid,
      space_key: spaceKey,
      live_id: liveId,
      created_at: FS.serverTimestamp(),
    }),
  ])
}

/**
 * ライブ視聴を明示的に終了する。left_at を現在時刻に設定する。
 */
export function leaveLiveViewer(
  firestore: FS.Firestore,
  user: FirebaseAuth.User,
  spaceKey: SpaceKey,
  liveId: LiveId,
) {
  return FS.updateDoc(FS.doc(firestore, FirestorePaths.Spaces.Lives.LiveViewers.getDocPath(spaceKey, liveId, user.uid as UserId)), {
    updated_at: FS.serverTimestamp(),
    left_at: FS.serverTimestamp(),
  })
}

export function useLiveViewer(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, userId: UserId): LoadingOption<LiveViewerDocumentBody> {
  return useDocument(firestore, FirestorePaths.Spaces.Lives.LiveViewers.getPath(spaceKey, liveId), userId, LiveViewerDocuments.fromDocumentSnapshot)
}

export function useLiveViewersList(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId): Loading<LiveViewerDocumentBody[]> {
  return useCollection(firestore, FirestorePaths.Spaces.Lives.LiveViewers.getPath(spaceKey, liveId), LiveViewerDocuments.fromDocumentSnapshot, undefined, [FS.orderBy("created_at", "desc")])
}

export function useLiveComments(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, limit: number): Loading<LiveCommentDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.Lives.LiveComments.getPath(spaceKey, liveId), LiveCommentDocuments.fromDocumentSnapshot, limit)
}

/**
 * ライブコメントの削除イベントを購読する。
 * クライアントは購読範囲外のコメント削除を検知するためにこのフックを使用する。
 */
export function useLiveCommentDeletions(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId): Loading<LiveCommentDeletionDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.LiveCommentDeletions.getPath(spaceKey, liveId),
    LiveCommentDeletionDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSelection(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): LoadingOption<SelectionDocument> {
  return useDocument(firestore, FirestorePaths.Spaces.Lives.Selections.getPath(spaceKey, liveId), selectionId, SelectionDocuments.fromDocumentSnapshot)
}

export function useSelections(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, limit: number): Loading<SelectionDocument[]> {
  return useCollection(firestore, FirestorePaths.Spaces.Lives.Selections.getPath(spaceKey, liveId), SelectionDocuments.fromDocumentSnapshot, limit)
}

export function useSelectionSequence(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, sequenceId: SelectionSequenceId): LoadingOption<SelectionSequenceDocument> {
  return useDocument(firestore, FirestorePaths.Spaces.Lives.Selections.SelectionSequences.getPath(spaceKey, liveId, selectionId), sequenceId, SelectionSequenceDocuments.fromDocumentSnapshot)
}

export function useSelectionSequences(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): Loading<SelectionSequenceDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.Selections.SelectionSequences.getPath(spaceKey, liveId, selectionId),
    SelectionSequenceDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSelectionPseudoNominates(
  firestore: FS.Firestore,
  spaceKey: SpaceKey,
  liveId: LiveId,
  selectionId: SelectionId,
): Loading<SelectionParticipantPseudoNominateDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.Selections.SelectionPseudoNominates.getPath(spaceKey, liveId, selectionId),
    SelectionParticipantPseudoNominateDocuments.fromDocumentSnapshot,
  )
}

export function useSelectionNominates(
  firestore: FS.Firestore,
  spaceKey: SpaceKey,
  liveId: LiveId,
  selectionId: SelectionId,
): Loading<SelectionParticipantNominateDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.Selections.SelectionNominates.getPath(spaceKey, liveId, selectionId),
    SelectionParticipantNominateDocuments.fromDocumentSnapshot,
  )
}

export function useSelectionParticipants(firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId): Loading<SelectionParticipantNominateDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.Selections.SelectionParticipants.getPath(spaceKey, liveId, selectionId),
    SelectionParticipantNominateDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSelectionParticipantsByUserId(
  firestore: FS.Firestore, spaceKey: SpaceKey, liveId: LiveId, selectionId: SelectionId, userId: UserId): Loading<SelectionParticipantNominateDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Spaces.Lives.Selections.SelectionParticipants.getPath(spaceKey, liveId, selectionId),
    SelectionParticipantNominateDocuments.fromDocumentSnapshot,
    undefined,
    [FS.where("user.id", "==", userId)]
  )
}

export function useTopicSuggestions(firestore: FS.Firestore): Loading<TopicSuggestionDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.TopicSuggestions.path,
    TopicSuggestions.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSystemNotifications(firestore: FS.Firestore): Loading<SystemNotificationDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SystemNotifications.path,
    SystemNotificationDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSystemNotification(firestore: FS.Firestore, id: SystemNotificationId): LoadingOption<SystemNotificationDocument> {
  return useDocument(firestore, FirestorePaths.SystemNotifications.path, id, SystemNotificationDocuments.fromDocumentSnapshot)
}

export type SystemNotificationListingFilter = "all" | "listed" | "unlisted"

export function useSystemNotificationsPage(
  firestore: FS.Firestore,
  pagePosition: PagePosition,
  listingFilter: SystemNotificationListingFilter = "all"
): Loading<PageResult<SystemNotificationDocument>> {
  const baseQuery = useMemo(() => {
    const collectionRef = FS.collection(firestore, FirestorePaths.SystemNotifications.path)

    if (listingFilter === "listed") {
      return FS.query(
        collectionRef,
        FS.where("status", "==", "public"),
        FS.where("display_period_state.active", "==", true),
        FS.orderBy("display_period.start_at", "desc")
      )
    } else if (listingFilter === "unlisted") {
      return FS.query(
        collectionRef,
        FS.or(
          FS.and(
            FS.where("status", "==", "hidden"),
            FS.where("display_period_state.active", "==", true)
          ),
          FS.and(
            FS.where("status", "==", "hidden"),
            FS.where("display_period_state.active", "==", false)
          ),
          FS.and(
            FS.where("status", "==", "public"),
            FS.where("display_period_state.active", "==", false)
          )
        ),
        FS.orderBy("display_period.start_at", "desc")
      )
    }

    return FS.query(collectionRef, FS.orderBy("created_at", "desc"))
  }, [firestore, listingFilter])

  const getPivotDocRef = useCallback(
    (docId: string) => FS.doc(firestore, `${FirestorePaths.SystemNotifications.path}/${docId}`),
    [firestore]
  )

  const converter = useCallback(
    (doc: DocumentSnapshotLike) => SystemNotificationDocuments.fromDocumentSnapshot(doc),
    []
  )

  return useQueryPage(baseQuery, getPivotDocRef, converter, pagePosition)
}

export function useManagedImagesPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<ManagedImageDocument>> {
  return useCollectionPage(firestore, FirestorePaths.ManagedImages.path, ManagedImageDocuments.fromDocumentSnapshot, pagePosition)
}

export function useCountManagedImages(firestore: FS.Firestore): Loading<number> {
  return useTotalCount(firestore, FirestorePaths.ManagedImages.path)
}

export async function fetchManagedImagesAll(firestore: FS.Firestore): Promise<ManagedImageDocument[]> {
  const snapshot = await FS.getDocs(FS.collection(firestore, FirestorePaths.ManagedImages.path))
  return snapshot.docs.map(ManagedImageDocuments.fromDocumentSnapshot).filter(nonNullable)
}

export function useManagedImage(firestore: FS.Firestore, id: ManagedImageId): LoadingOption<ManagedImageDocument> {
  return useDocument(firestore, FirestorePaths.ManagedImages.path, id, ManagedImageDocuments.fromDocumentSnapshot)
}

export function useManagedImagesWithUsageTypes(
  firestore: FS.Firestore,
  usageTypes: ManagedImageUsageType[]
): Loading<ManagedImageDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.ManagedImages.path,
    ManagedImageDocuments.fromDocumentSnapshot,
    1000,
    [
      FS.where("usage_types", "array-contains-any", usageTypes),
      FS.orderBy("created_at", "desc")
    ]
  )
}

export function usePublicSystemNotifications(firestore: FS.Firestore, limit: number = 50): Loading<SystemNotificationDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SystemNotifications.path,
    SystemNotificationDocuments.fromDocumentSnapshot,
    limit,
    [
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      FS.orderBy("display_period.start_at", "desc")
    ]
  )
}

export function useShopBanners(firestore: FS.Firestore, limit: number = 50): Loading<ShopBannerDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.ShopBanners.path,
    ShopBannerDocuments.fromDocumentSnapshot,
    limit,
    [
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      FS.orderBy("priority", "desc")
    ]
  )
}

export function useShopBannersAll(firestore: FS.Firestore): Loading<ShopBannerDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.ShopBanners.path,
    ShopBannerDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export async function fetchShopBannersAll(firestore: FS.Firestore): Promise<ShopBannerDocument[]> {
  const q = FS.query(FS.collection(firestore, FirestorePaths.ShopBanners.path), FS.orderBy("created_at", "desc"))
  const snapshot = await FS.getDocs(q)
  return snapshot.docs.map(ShopBannerDocuments.fromDocumentSnapshot).filter(nonNullable)
}

export function useShopCustomTagsAll(firestore: FS.Firestore): Loading<ShopCustomTagDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.ShopCustomTags.path,
    ShopCustomTagDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export async function fetchShopCustomTagsAll(firestore: FS.Firestore): Promise<ShopCustomTagDocument[]> {
  const q = FS.query(FS.collection(firestore, FirestorePaths.ShopCustomTags.path), FS.orderBy("created_at", "desc"))
  const snapshot = await FS.getDocs(q)
  return snapshot.docs.map(ShopCustomTagDocuments.fromDocumentSnapshot).filter(nonNullable)
}

export function useShopCustomTag(firestore: FS.Firestore, id: ShopCustomTagId): LoadingOption<ShopCustomTagDocument> {
  return useDocument(firestore, FirestorePaths.ShopCustomTags.path, id, ShopCustomTagDocuments.fromDocumentSnapshot)
}

export function useShopBanner(firestore: FS.Firestore, id: ShopBannerId): LoadingOption<ShopBannerDocument> {
  return useDocument(firestore, FirestorePaths.ShopBanners.path, id, ShopBannerDocuments.fromDocumentSnapshot)
}

export function useHomeBannersAll(firestore: FS.Firestore): Loading<HomeBannerDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.HomeBanners.path,
    HomeBannerDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.orderBy("priority", "desc"),
      FS.orderBy("created_at", "desc")
    ]
  )
}

export function useHomeBanner(firestore: FS.Firestore, id: HomeBannerId): LoadingOption<HomeBannerDocument> {
  return useDocument(firestore, FirestorePaths.HomeBanners.path, id, HomeBannerDocuments.fromDocumentSnapshot)
}

export function useHomePickupsAll(firestore: FS.Firestore): Loading<HomePickupDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.HomePickups.path,
    HomePickupDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.orderBy("created_at", "desc")
    ]
  )
}

export function usePinnedStoryUsersAll(firestore: FS.Firestore): Loading<PinnedStoryUserDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.PinnedStoryUsers.path,
    PinnedStoryUserDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.orderBy("priority", "desc"),
      FS.orderBy("created_at", "desc")
    ]
  )
}

export function usePinnedStoryUser(firestore: FS.Firestore, id: PinnedStoryUserId): LoadingOption<PinnedStoryUserDocument> {
  return useDocument(firestore, FirestorePaths.PinnedStoryUsers.path, id, PinnedStoryUserDocuments.fromDocumentSnapshot)
}

export function useHomeLivePinsAll(firestore: FS.Firestore): Loading<HomeLivePinDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.HomeLivePins.path,
    HomeLivePinDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.orderBy("priority", "desc"),
      FS.orderBy("created_at", "desc")
    ]
  )
}

export function useHomeLivePin(firestore: FS.Firestore, id: HomeLivePinId): LoadingOption<HomeLivePinDocument> {
  return useDocument(firestore, FirestorePaths.HomeLivePins.path, id, HomeLivePinDocuments.fromDocumentSnapshot)
}

export function useMaintenanceDocument(firestore: FS.Firestore): LoadingOption<AppConfigMaintenanceDocumentBody> {
  return useDocument(
    firestore,
    FirestorePaths.AppConfigs.path,
    MaintenanceDocuments.DOCUMENT_ID,
    MaintenanceDocuments.fromDocumentSnapshot
  )
}

export function useMaintenanceSchedules(firestore: FS.Firestore): Loading<MaintenanceScheduleEntry[]> {
  const maintenanceDoc = useMaintenanceDocument(firestore)

  if (maintenanceDoc === "loading") {
    return "loading"
  }

  const schedules = maintenanceDoc?.schedules ?? []
  return schedules.sort((a, b) => b.created_at - a.created_at)
}

export function useSalesAll(firestore: FS.Firestore): Loading<SaleDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Sales.path,
    SaleDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export async function fetchSalesAll(firestore: FS.Firestore): Promise<SaleDocument[]> {
  const q = FS.query(FS.collection(firestore, FirestorePaths.Sales.path), FS.orderBy("created_at", "desc"))
  const snapshot = await FS.getDocs(q)
  return snapshot.docs.map(SaleDocuments.fromDocumentSnapshot).filter(nonNullable)
}

export function useSale(firestore: FS.Firestore, id: SaleId): LoadingOption<SaleDocument> {
  return useDocument(firestore, FirestorePaths.Sales.path, id, SaleDocuments.fromDocumentSnapshot)
}

export function useShopTopCompositionFirst(firestore: FS.Firestore): LoadingOption<ShopTopCompositionFirstDocument> {
  return useDocument(
    firestore,
    FirestorePaths.ShopTopCompositions.path,
    ShopTopCompositionDocumentIds.first,
    ShopTopCompositionFirstDocuments.fromDocumentSnapshot
  )
}

export async function fetchShopTopCompositionFirst(firestore: FS.Firestore): Promise<ShopTopCompositionFirstDocument | null> {
  const docRef = FS.doc(firestore, FirestorePaths.ShopTopCompositions.path, ShopTopCompositionDocumentIds.first)
  const snapshot = await FS.getDoc(docRef)
  return ShopTopCompositionFirstDocuments.fromDocumentSnapshot(snapshot)
}

export function useShopTopCompositionList(firestore: FS.Firestore): LoadingOption<ShopTopCompositionListDocument> {
  return useDocument(
    firestore,
    FirestorePaths.ShopTopCompositions.path,
    ShopTopCompositionDocumentIds.list,
    ShopTopCompositionListDocuments.fromDocumentSnapshot
  )
}

export async function fetchShopTopCompositionList(firestore: FS.Firestore): Promise<ShopTopCompositionListDocument | null> {
  const docRef = FS.doc(firestore, FirestorePaths.ShopTopCompositions.path, ShopTopCompositionDocumentIds.list)
  const snapshot = await FS.getDoc(docRef)
  return ShopTopCompositionListDocuments.fromDocumentSnapshot(snapshot)
}

export function useMaintenanceSchedule(firestore: FS.Firestore, id: MaintenanceScheduleEntryId): LoadingOption<MaintenanceScheduleEntry> {
  const maintenanceDoc = useMaintenanceDocument(firestore)

  if (maintenanceDoc === "loading") {
    return "loading"
  }

  if (!maintenanceDoc) {
    return null
  }

  return MaintenanceDocuments.getEntryById(maintenanceDoc, id)
}

export function useNewSystemNotifications(firestore: FS.Firestore, lastCheckedAt?: number): Loading<boolean> {
  const [result, setResult] = useState<Loading<boolean>>("loading")

  useEffect(() => {
    const queryConstraints = [
      FS.where("status", "==", "public"),
      FS.where("display_period_state.active", "==", true),
      ...(lastCheckedAt == null ? [] : [FS.where("display_period.start_at", ">", lastCheckedAt)])
    ]

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.SystemNotifications.path),
      ...queryConstraints
    )

    const unsubscribe = FS.onSnapshot(query,
      (snapshot) => {
        setResult(0 < snapshot.size)
      },
      (error) => {
        console.error("Error in useNewSystemNotifications:", error)
        setResult(false)
      }
    )

    return () => unsubscribe()
  }, [firestore, lastCheckedAt])

  return result
}

export function useSystemNotificationReadStatus(firestore: FS.Firestore, userId: UserId, notificationId: SystemNotificationId): LoadingOption<SystemNotificationReadStatusDocument> {
  return useDocument(
    firestore,
    FirestorePaths.Users.SystemNotificationReadStatuses.getPath(userId),
    notificationId,
    SystemNotificationReadStatusDocuments.fromDocumentSnapshot
  )
}

export function useSystemNotificationReadStatuses(firestore: FS.Firestore, userId: UserId, notificationIds: SystemNotificationId[]): Loading<SystemNotificationReadStatusDocument[]> {
  const [result, setResult] = useState<Loading<SystemNotificationReadStatusDocument[]>>("loading")

  useEffect(() => {
    if (notificationIds.length === 0) {
      setResult([])
      return
    }

    void (async () => {
      try {
        // Firestore IN query limit is 30, so we need to chunk
        const chunks = []
        for (let i = 0; i < notificationIds.length; i += 30) {
          chunks.push(notificationIds.slice(i, i + 30))
        }

        const allResults: SystemNotificationReadStatusDocument[] = []

        for (const chunk of chunks) {
          const query = FS.query(
            FS.collection(firestore, FirestorePaths.Users.SystemNotificationReadStatuses.getPath(userId)),
            FS.where(FS.documentId(), "in", chunk)
          )

          const snapshot = await FS.getDocs(query)
          const chunkResults = snapshot.docs.map(SystemNotificationReadStatusDocuments.fromDocumentSnapshot).filter(nonNullable)
          allResults.push(...chunkResults)
        }

        setResult(allResults)
      } catch (e) {
        await FirestoreAccess.handleAuthorityErrorAsEmpty(e as Error, FirestorePaths.Users.SystemNotificationReadStatuses.getPath(userId))
        setResult([])
      }
    })()
  }, [firestore, userId, notificationIds])

  return result
}

export async function markSystemNotificationAsRead(
  firestore: FS.Firestore,
  userId: UserId,
  notificationId: SystemNotificationId
): Promise<void> {
  await FS.setDoc(
    FS.doc(firestore, FirestorePaths.Users.SystemNotificationReadStatuses.getDocPath(userId, notificationId)),
    {
      system_notification_id: notificationId,
      read_at: FS.serverTimestamp(),
      has_seen_launch_popup: false,
    },
    { merge: true }
  )
}

export function useSystemNotificationLaunchPopups(firestore: FS.Firestore): Loading<SystemNotificationDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SystemNotifications.path,
    SystemNotificationDocuments.fromDocumentSnapshot,
    50,
    [
      FS.where("status", "==", "public"),
      FS.where("launch_popup_period_state.active", "==", true)
    ]
  )
}

export async function markSystemNotificationAsSeenLaunchPopup(
  firestore: FS.Firestore,
  userId: UserId,
  notificationId: SystemNotificationId
): Promise<void> {
  await FS.setDoc(
    FS.doc(firestore, FirestorePaths.Users.SystemNotificationReadStatuses.getDocPath(userId, notificationId)),
    {
      system_notification_id: notificationId,
      read_at: FS.serverTimestamp(),
      has_seen_launch_popup: true,
    },
    { merge: true }
  )
}

function useDocument<T>(firestore: FS.Firestore, path: string, id: LoadingOption<string>, converter: (doc: DocumentSnapshotLike | null) => T | null): LoadingOption<T> {
  const [document, setDocument] = useState<LoadingOption<DocumentSnapshotLike>>("loading")

  useEffect(() => {
    if (id === "loading" || id === "" || path.indexOf("//") !== -1) {
      setDocument("loading")
      return
    }
    if (id === null) {
      setDocument(null)
      return
    }

    const ref = FS.doc(firestore, path + "/" + id)

    const subscription = fromRef(ref, { includeMetadataChanges: true })
      .pipe(
        Rx.catchError((e) => FirestoreAccess.handleAuthorityErrorAsNull(e, path + "/" + id)),
        Rx.map((doc) => setDocument(doc)),
      )
      .subscribe()

    return () => subscription.unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, id])

  return document === "loading" ? "loading" : converter(document)
}

function useCollectionWithCompositeFilter<T>(
  firestore: FS.Firestore,
  path: string,
  converter: (doc: DocumentSnapshotLike) => T | null,
  compositeFilter: QueryCompositeFilterConstraint,
  filter: QueryNonFilterConstraint[]
): Loading<T[]> {
  const query = FS.query(FS.collection(firestore, path), compositeFilter, ...filter)
  return useObservable<Loading<T[]>>(
    () =>
      fromRef(query, { includeMetadataChanges: true }).pipe(
        Rx.map((e) => e.docs),
        Rx.catchError((e) => FirestoreAccess.handleAuthorityErrorAsEmpty(e, path)),
        Rx.map((docs) => {
          return docs.map(converter).filter(nonNullable)
        }),
      ),
    "loading" as const,
  )
}

function useCollection<T>(
  firestore: FS.Firestore,
  path: string,
  converter: (doc: DocumentSnapshotLike) => T | null,
  limit: number | undefined = undefined,
  queries: QueryConstraint[] = [],
): Loading<T[]> {
  const query = FS.query(FS.collection(firestore, path), ...queries.concat(limit ? [FS.limit(limit)] : []))

  return useObservable<Loading<T[]>>(
    () =>
      fromRef(query, { includeMetadataChanges: true }).pipe(
        Rx.map((e) => e.docs),
        Rx.catchError((e) => FirestoreAccess.handleAuthorityErrorAsEmpty(e, path)),
        Rx.map((docs) => {
          return docs.map(converter).filter(nonNullable)
        }),
      ),
    "loading" as const,
  )
}

function useCollectionGroupFromQuery<T>(
  query: FS.Query,
  path: string,
  converter: (doc: DocumentSnapshotLike) => T | null,
): Loading<(T & { _path: string[] })[]> {
  return useObservable<Loading<(T & { _path: string[] })[]>>(
    () =>
      fromRef(query, { includeMetadataChanges: true }).pipe(
        Rx.map((e) => e.docs),
        Rx.catchError((e) => FirestoreAccess.handleAuthorityErrorAsEmpty(e, path)),
        Rx.map((docs) => {
          return docs
            .map((doc) => {
              const value = converter(doc)
              if (value === null) {
                return null
              }
              return { ...value, _path: doc.ref.path.split("/") }
            })
            .filter(nonNullable)
        }),
      ),
    "loading" as const,
  )
}


function useTotalCount(firestore: FS.Firestore, path: string): Loading<number> {
  const query = FS.query(FS.collection(firestore, path))
  return useTotalCountFromQuery(query)
}

function useTotalCountFromQuery(query: FS.Query): Loading<number> {
  const [result, setResult] = useState<Loading<number>>("loading")
  useEffect(() => {
    void (async () => {
      const snapshot = await FS.getCountFromServer(query)
      setResult(snapshot.data().count)
    })()
  })
  return result
}

function useCollectionPage<T>(
  firestore: FS.Firestore,
  path: string,
  converter: (doc: DocumentSnapshotLike) => T | null,
  pagePosition: PagePosition,
  options: {
    ordering: {
      field: string,
      direction: "asc" | "desc"
    }
  } = {
    ordering: {
      field: "created_at",
      direction: "desc",
    }
  }
): Loading<PageResult<T>> {
  const colRef = FS.collection(firestore, path)
  const [result, setResult] = useState<Loading<{ docs: T[]; next?: string; prev?: string }>>("loading")
  const [pivot, setPivot] = useState<LoadingOption<FS.DocumentSnapshot>>("loading")

  useEffect(() => {
    let cancelled = false
    const id = pagePosition.start ?? pagePosition.until
    if (id == null) {
      setPivot(null)
    } else {
      void (async () => {
        const pivotDoc = await FS.getDoc(FS.doc(firestore, path + "/" + id))
        if (!cancelled) {
          if (pivotDoc.exists()) {
            setPivot(pivotDoc)
          } else {
            // pivot doc が存在しない場合は初回ページ表示と同等の振る舞いとする
            setPivot(null)
          }
        }
      })()
    }
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, pagePosition.start, pagePosition.until, pagePosition.pageSize])

  const pagedQuery = useMemo(() => {
    if (pivot === "loading") {
      return undefined
    }
    return FS.query(
      colRef,
      FS.orderBy(options.ordering.field, options.ordering.direction),
      ...(pivot
        ? pagePosition.until
          ? [FS.endBefore(pivot), FS.limitToLast(pagePosition.pageSize + 1)]
          : [FS.startAt(pivot), FS.limit(pagePosition.pageSize + 1)]
        : [FS.limit(pagePosition.pageSize + 1)]),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, pivot, pagePosition.pageSize, pagePosition.until, pagePosition.start])

  useEffect(() => {
    void (async () => {
      if (pagedQuery == null) {
        return
      }
      const { docs } = await FS.getDocs(pagedQuery)

      if (pivot && pagePosition.until) {
        setResult({
          docs: docs.slice(-pagePosition.pageSize).map((doc) => converter(doc) as T),
          next: pagePosition.until,
          prev: docs.length === pagePosition.pageSize + 1 ? docs[1].id : undefined,
        })
      } else {
        setResult({
          docs: docs.slice(0, pagePosition.pageSize).map((doc) => converter(doc) as T),
          next: docs.length === pagePosition.pageSize + 1 ? docs[docs.length - 1].id : undefined,
          prev: pagePosition.start,
        })
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pivot, pagedQuery])

  return result
}

export function useQueryPage<T>(
  baseQuery: FS.Query<FS.DocumentData>,
  getPivotDocRef: (docId: string) => FS.DocumentReference<FS.DocumentData>,
  converter: (doc: DocumentSnapshotLike) => T | null,
  pagePosition: PagePosition
): Loading<PageResult<T>> {
  const [result, setResult] = useState<Loading<PageResult<T>>>("loading")
  const [pivot, setPivot] = useState<LoadingOption<FS.DocumentSnapshot>>("loading")

  useEffect(() => {
    let cancelled = false
    const id = pagePosition.start ?? pagePosition.until
    if (id == null) {
      setPivot(null)
    } else {
      void (async () => {
        try {
          const pivotDocRef = getPivotDocRef(id)
          const pivotDoc = await FS.getDoc(pivotDocRef)
          if (!cancelled) {
            if (pivotDoc.exists()) {
              setPivot(pivotDoc)
            } else {
              setPivot(null)
            }
          }
        } catch (error) {
          if (!cancelled) {
            console.warn("Error getting pivot document:", error)
            setPivot(null)
          }
        }
      })()
    }
    return () => { cancelled = true }
  }, [getPivotDocRef, pagePosition.start, pagePosition.until])

  const pagedQuery = useMemo(() => {
    if (pivot === "loading") {
      return undefined
    }

    let query = baseQuery

    if (pivot) {
      if (pagePosition.until) {
        query = FS.query(query, FS.endBefore(pivot), FS.limitToLast(pagePosition.pageSize + 1))
      } else {
        query = FS.query(query, FS.startAt(pivot), FS.limit(pagePosition.pageSize + 1))
      }
    } else {
      query = FS.query(query, FS.limit(pagePosition.pageSize + 1))
    }

    return query
  }, [baseQuery, pivot, pagePosition.pageSize, pagePosition.until])

  useEffect(() => {
    if (pagedQuery == null) {
      return
    }

    const unsubscribe = FS.onSnapshot(
      pagedQuery,
      (snapshot) => {
        const docs = snapshot.docs

        if (pivot && pagePosition.until) {
          setResult({
            docs: docs.slice(-pagePosition.pageSize).map((doc) => converter(doc) as T),
            next: pagePosition.until,
            prev: docs.length === pagePosition.pageSize + 1 ? docs[1].id : undefined,
          })
        } else {
          setResult({
            docs: docs.slice(0, pagePosition.pageSize).map((doc) => converter(doc) as T),
            next: docs.length === pagePosition.pageSize + 1 ? docs[docs.length - 1].id : undefined,
            prev: pagePosition.start,
          })
        }
      },
      (error) => {
        console.error("Error executing paged query:", error)
        setResult("loading")
      }
    )

    return () => unsubscribe()
  }, [pagedQuery, converter, pivot, pagePosition.pageSize, pagePosition.start, pagePosition.until])

  return result
}

export function useUserSystemNotificationCheckStatus(firestore: FS.Firestore, userId: UserId): LoadingOption<UserSystemNotificationCheckStatusDocument> {
  return useDocument(
    firestore,
    FirestorePaths.UserSystemNotificationCheckStatuses.path,
    userId,
    UserSystemNotificationCheckStatusDocuments.fromDocumentSnapshot
  )
}

export function useUserPrivate(firestore: FS.Firestore, userId: UserId): LoadingOption<UserPrivateDocument> {
  return useDocument(
    firestore,
    FirestorePaths.UserPrivates.path,
    userId,
    UserPrivateDocuments.fromDocumentSnapshot
  )
}

export function useUserSetting(firestore: FS.Firestore, userId: UserId, targetUserId: UserId): LoadingOption<UserSettingDocument> {
  return useDocument(
    firestore,
    FirestorePaths.UserPrivates.UserSettings.getPath(userId),
    targetUserId,
    UserSettingDocuments.fromDocumentSnapshot
  )
}

export async function updateUserSystemNotificationLastCheckedAt(
  firestore: FS.Firestore,
  userId: UserId
): Promise<void> {
  await FS.setDoc(
    FS.doc(firestore, FirestorePaths.UserSystemNotificationCheckStatuses.getDocPath(userId)),
    {
      last_checked_at: FS.serverTimestamp(),
    },
    { merge: true }
  )
}

export type BulkDeliveryMastersPageFilters = {
  statuses?: string[]
  contentType?: "coin" | "item"
}

export function useBulkDeliveryMastersPage<K extends BulkDeliveryMasterKind>(
  firestore: FS.Firestore,
  kind: K,
  pagePosition: PagePosition,
  filters?: BulkDeliveryMastersPageFilters
): Loading<PageResult<BulkDeliveryMaster<K>>> {
  const baseQuery = useMemo(() => {
    const constraints: QueryConstraint[] = [
      FS.where("kind", "==", kind),
    ]

    const hasStatusFilter = filters?.statuses && 0 < filters.statuses.length
    const hasContentTypeFilter = filters?.contentType && kind === BulkDeliveryMasterKind.Compensation

    if (hasStatusFilter) {
      constraints.push(FS.where("status", "in", filters.statuses))
    } else if (hasContentTypeFilter) {
      // インデックスを有効に活用するためにあえて status を指定
      const allStatuses = Object.values(BulkDeliveryMasterStatus)
      constraints.push(FS.where("status", "in", allStatuses))
    }

    if (hasContentTypeFilter) {
      constraints.push(FS.where("payload.delivery_content.kind", "==", filters.contentType))
    }

    constraints.push(FS.orderBy("created_at", "desc"))

    return FS.query(
      FS.collection(firestore, FirestorePaths.BulkDeliveryMasters.path),
      ...constraints
    )
  }, [firestore, kind, filters?.statuses, filters?.contentType])

  const getPivotDocRef = useCallback((docId: string) =>
      FS.doc(firestore, FirestorePaths.BulkDeliveryMasters.path, docId),
    [firestore]
  )

  return useQueryPage(
    baseQuery,
    getPivotDocRef,
    BulkDeliveryMasterDocuments.fromDocumentSnapshot,
    pagePosition
  ) as Loading<PageResult<BulkDeliveryMaster<K>>>
}

export function useBulkDeliveryMaster(
  firestore: FS.Firestore,
  masterId: string
): Loading<BulkDeliveryMaster | null> {
  return useDocument(
    firestore,
    FirestorePaths.BulkDeliveryMasters.path,
    masterId,
    BulkDeliveryMasterDocuments.fromDocumentSnapshot
  )
}

export function useWelcomeDeliveryMastersPage(
  firestore: FS.Firestore,
  pagePosition: PagePosition,
  activeOnly?: boolean
): Loading<PageResult<WelcomeDeliveryMaster>> {
  const now = useMemo(() => Date.now(), [])

  const baseQuery = useMemo(() => {
    const constraints: FS.QueryConstraint[] = activeOnly
      ? [
          FS.where("target_user_created_period.start_at", "<=", now),
          FS.where("target_user_created_period.end_at", ">", now),
        ]
      : [FS.orderBy("created_at", "desc")]
    return FS.query(
      FS.collection(firestore, FirestorePaths.WelcomeDeliveryMasters.path),
      ...constraints
    )
  }, [firestore, activeOnly, now])

  const getPivotDocRef = useCallback(
    (docId: string) =>
      FS.doc(firestore, FirestorePaths.WelcomeDeliveryMasters.path, docId),
    [firestore]
  )

  return useQueryPage(
    baseQuery,
    getPivotDocRef,
    WelcomeDeliveryMasterDocuments.fromDocumentSnapshot,
    pagePosition
  )
}

export function useWelcomeDeliveryMaster(
  firestore: FS.Firestore,
  masterId: string
): Loading<WelcomeDeliveryMaster | null> {
  return useDocument(
    firestore,
    FirestorePaths.WelcomeDeliveryMasters.path,
    masterId,
    WelcomeDeliveryMasterDocuments.fromDocumentSnapshot
  )
}

export function useWelcomeDeliveryMasterByOriginBulkDeliveryId(
  firestore: FS.Firestore,
  originBulkDeliveryId: string
): Loading<WelcomeDeliveryMaster | null> {
  const [data, setData] = useState<Loading<WelcomeDeliveryMaster | null>>("loading")

  useEffect(() => {
    const query = FS.query(
      FS.collection(firestore, FirestorePaths.WelcomeDeliveryMasters.path),
      FS.where("origin_bulk_delivery_id", "==", originBulkDeliveryId),
      FS.limit(1)
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        if (snapshot.empty) {
          setData(null)
        } else {
          const doc = WelcomeDeliveryMasterDocuments.fromDocumentSnapshot(snapshot.docs[0])
          setData(doc)
        }
      },
      (error) => {
        console.error("Error in useWelcomeDeliveryMasterByOriginBulkDeliveryId:", error)
        setData(null)
      }
    )

    return () => unsubscribe()
  }, [firestore, originBulkDeliveryId])

  return data
}

export function useBulkDeliveryTargetUserCount(
  firestore: FS.Firestore,
  masterId: string
): Loading<number | null> {
  const [data, setData] = useState<Loading<number | null>>("loading")

  useEffect(() => {
    if (!masterId) {
      setData(null)
      return
    }

    const fetchUserCount = async () => {
      const aggregateSnapshot = await getAggregateFromServer(
        collection(
          firestore,
          FirestorePaths.BulkDeliveryMasters.path,
          masterId,
          FirestorePaths.BulkDeliveryMasters.TargetChunks.path
        ),
        { totalUsers: sum("user_count") }
      )
      setData(aggregateSnapshot.data().totalUsers || 0)
    }

    void fetchUserCount()
  }, [firestore, masterId])

  return data
}

export function useCallPushesForUser(firestore: FS.Firestore, userId: UserId, limit?: number): Loading<CallPushDocument[]> {
  return useCollectionWithCompositeFilter(
    firestore,
    FirestorePaths.CallPushes.path,
    CallPushDocuments.fromDocumentSnapshot,
    FS.or(
      FS.where("caller_user", "==", userId),
      FS.where("callee_user", "==", userId)
    ),
    [FS.orderBy("created_at", "desc"), ...(limit ? [FS.limit(limit)] : [])],
  )
}

export function useCallPush(firestore: FS.Firestore, callPushId: CallPushId): LoadingOption<CallPushDocument> {
  return useDocument(firestore, FirestorePaths.CallPushes.path, callPushId, CallPushDocuments.fromDocumentSnapshot)
}

export function useCallPushesForSpace(firestore: FS.Firestore, spaceKey: SpaceKey, limit?: number): Loading<CallPushDocument[]> {
  return useCollectionWithCompositeFilter(
    firestore,
    FirestorePaths.CallPushes.path,
    CallPushDocuments.fromDocumentSnapshot,
    FS.and(
      FS.where("space", "==", spaceKey),
      FS.or(
        FS.where("kind", "==", "user-call"),
        FS.where("kind", "==", "space-friends-call-caller"),
        FS.where("kind", "==", "live-follower-call-caller")
      )
    ),
    [FS.orderBy("created_at", "desc"), ...(limit ? [FS.limit(limit)] : [])],
  )
}

export function useUserFromCallerCallId(
  firestore: FS.Firestore,
  callerCallId: string | null
): LoadingOption<string> {
  const [result, setResult] = useState<LoadingOption<string>>("loading")

  useEffect(() => {
    if (!callerCallId) {
      setResult(null)
      return
    }

    setResult("loading")

    const fetchCallPush = async () => {
      try {
        const docRef = FS.doc(firestore, FirestorePaths.CallPushes.path, callerCallId)
        const doc = await FS.getDoc(docRef)

        if (!doc.exists()) {
          setResult(null)
          return
        }

        const callPush = CallPushDocuments.fromDocumentSnapshot(doc)
        const callerUser = callPush && "caller_user" in callPush ? callPush.caller_user : null
        setResult(callerUser)
      } catch (err) {
        console.error("Error fetching caller user:", err)
        setResult(null)
      }
    }

    void fetchCallPush()
  }, [firestore, callerCallId])

  return result
}

export function useCallPushesForUserPage(
  firestore: FS.Firestore,
  userId: UserId,
  pagePosition: PagePosition
): Loading<PageResult<CallPushDocument>> {
  const baseQuery = useMemo(() => {
    return FS.query(
      FS.collection(firestore, FirestorePaths.CallPushes.path),
      FS.or(
        FS.where("caller_user", "==", userId),
        FS.where("callee_user", "==", userId)
      ),
      FS.orderBy("created_at", "desc")
    )
  }, [firestore, userId])

  const getPivotDocRef = useCallback(
    (docId: string) =>
      FS.doc(firestore, `${FirestorePaths.CallPushes.path}/${docId}`),
    [firestore]
  )

  const converter = useCallback(
    (doc: DocumentSnapshotLike) =>
      CallPushDocuments.fromDocumentSnapshot(doc),
    []
  )

  return useQueryPage(baseQuery, getPivotDocRef, converter, pagePosition)
}

export function useCallPushesForSpacePage(
  firestore: FS.Firestore,
  spaceKey: SpaceKey,
  pagePosition: PagePosition
): Loading<PageResult<CallPushDocument>> {
  const baseQuery = useMemo(() => {
    return FS.query(
      FS.collection(firestore, FirestorePaths.CallPushes.path),
      FS.and(
        FS.where("space", "==", spaceKey),
        FS.or(
          FS.where("kind", "==", "user-call"),
          FS.where("kind", "==", "space-friends-call-caller"),
          FS.where("kind", "==", "live-follower-call-caller")
        )
      ),
      FS.orderBy("created_at", "desc")
    )
  }, [firestore, spaceKey])

  const getPivotDocRef = useCallback(
    (docId: string) =>
      FS.doc(firestore, `${FirestorePaths.CallPushes.path}/${docId}`),
    [firestore]
  )

  const converter = useCallback(
    (doc: DocumentSnapshotLike) =>
      CallPushDocuments.fromDocumentSnapshot(doc),
    []
  )

  return useQueryPage(baseQuery, getPivotDocRef, converter, pagePosition)
}


export function useCallPushesCountForUser(firestore: FS.Firestore, userId: UserId): Loading<number> {
  const query = FS.query(
    FS.collection(firestore, FirestorePaths.CallPushes.path),
    FS.or(
      FS.where("caller_user", "==", userId),
      FS.where("callee_user", "==", userId)
    )
  )
  return useTotalCountFromQuery(query)
}

export function useCallPushesCountForSpace(firestore: FS.Firestore, spaceKey: SpaceKey): Loading<number> {
  const query = FS.query(
    FS.collection(firestore, FirestorePaths.CallPushes.path),
    FS.and(
      FS.where("space", "==", spaceKey),
      FS.or(
        FS.where("kind", "==", "user-call"),
        FS.where("kind", "==", "space-friends-call-caller"),
        FS.where("kind", "==", "live-follower-call-caller")
      )
    ),
  )
  return useTotalCountFromQuery(query)
}

export function useCalleeFromCallerCallId(firestore: FS.Firestore, callerCallId: CallPushId): Loading<CallPushDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.CallPushes.path,
    CallPushDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.where("caller_call_id", "==", callerCallId),
      FS.orderBy("created_at", "desc")
    ]
  )
}

type BulkDeliveryProgressResult = {
  completedUsers: number
  failedUsers: number
  skippedUsers: number
}

function useBulkDeliveryProgress(
  firestore: FS.Firestore,
  masterId: string,
  resultPrefix: "delivery_result" | "deletion_result"
): Loading<BulkDeliveryProgressResult | null> {
  const [data, setData] = useState<Loading<BulkDeliveryProgressResult | null>>("loading")

  useEffect(() => {
    if (!masterId) {
      setData(null)
      return
    }

    const fetchProgress = async () => {
      const chunksRef = collection(
        firestore,
        FirestorePaths.BulkDeliveryMasters.path,
        masterId,
        FirestorePaths.BulkDeliveryMasters.TargetChunks.path
      )

      const [
        completedUsersSnapshot,
        failedUsersSnapshot,
        skippedUsersSnapshot
      ] = await Promise.all([
        getAggregateFromServer(chunksRef, {
          completedUsers: sum(`${resultPrefix}.successful_count`)
        }),
        getAggregateFromServer(chunksRef, {
          failedUsers: sum(`${resultPrefix}.failed_count`)
        }),
        getAggregateFromServer(chunksRef, {
          skippedUsers: sum(`${resultPrefix}.skipped_count`)
        })
      ])

      const completedUsers = completedUsersSnapshot.data().completedUsers || 0
      const failedUsers = failedUsersSnapshot.data().failedUsers || 0
      const skippedUsers = skippedUsersSnapshot.data().skippedUsers || 0

      setData({
        completedUsers,
        failedUsers,
        skippedUsers
      })
    }

    void fetchProgress()
  }, [firestore, masterId, resultPrefix])

  return data
}

export function useBulkDeliveryProgressForDelivery(
  firestore: FS.Firestore,
  masterId: string
): Loading<BulkDeliveryProgressResult | null> {
  return useBulkDeliveryProgress(firestore, masterId, "delivery_result")
}

export function useBulkDeliveryProgressForDeletion(
  firestore: FS.Firestore,
  masterId: string
): Loading<BulkDeliveryProgressResult | null> {
  return useBulkDeliveryProgress(firestore, masterId, "deletion_result")
}

type BulkDeliveryUserIdsType =
  | "all_users"
  | "delivery_failed"
  | "delivery_skipped"
  | "deletion_failed"
  | "deletion_skipped"

export async function* streamBulkDeliveryUserIds(
  firestore: FS.Firestore,
  masterId: string,
  type: BulkDeliveryUserIdsType
): AsyncGenerator<string[], void, undefined> {
  const chunksRef = FS.collection(
    firestore,
    FirestorePaths.BulkDeliveryMasters.path,
    masterId,
    FirestorePaths.BulkDeliveryMasters.TargetChunks.path
  )

  const snapshot = await FS.getDocs(chunksRef)

  for (const doc of snapshot.docs) {
    const data = doc.data()
    let userIds: string[] = []

    switch (type) {
      case "all_users":
        userIds = data["user_ids"] || []
        break
      case "delivery_failed":
        userIds = data["delivery_result"]?.["failed_user_ids"] || []
        break
      case "delivery_skipped":
        userIds = data["delivery_result"]?.["skipped_user_ids"] || []
        break
      case "deletion_failed":
        userIds = data["deletion_result"]?.["failed_user_ids"] || []
        break
      case "deletion_skipped":
        userIds = data["deletion_result"]?.["skipped_user_ids"] || []
        break
      default:
        assertNever(type)
    }

    if (0 < userIds.length) {
      yield userIds
    }
  }
}

export function useBulkDeliveryTargetChunksByStatus(
  firestore: FS.Firestore,
  status: BulkDeliveryTargetChunkStatus,
  limit: number = 1000
): Loading<BulkDeliveryTargetChunk[]> {
  return useCollectionGroupFromQuery(
    FS.query(
      FS.collectionGroup(firestore, FirestorePaths.BulkDeliveryMasters.TargetChunks.path),
      FS.where("status", "==", status),
      FS.orderBy("visible_start_at", "asc"),
      FS.limit(limit)
    ),
    FirestorePaths.BulkDeliveryMasters.TargetChunks.path,
    BulkDeliveryTargetChunkDocuments.fromDocumentSnapshot
  )
}

export function useBulkDeliveryTargetChunksCountByStatus(
  firestore: FS.Firestore,
  status: BulkDeliveryTargetChunkStatus
): Loading<number> {
  return useTotalCountFromQuery(
    FS.query(
      FS.collectionGroup(firestore, FirestorePaths.BulkDeliveryMasters.TargetChunks.path),
      FS.where("status", "==", status)
    )
  )
}

/**
 * 配信済みユーザー数をリアルタイムで取得
 */
export function useWelcomeDeliveryDeliveredUserCount(
  firestore: FS.Firestore,
  masterId: string
): Loading<number | null> {
  const [data, setData] = useState<Loading<number | null>>("loading")

  useEffect(() => {
    const unsubscribe = FS.onSnapshot(
      FS.collection(
        firestore,
        FirestorePaths.WelcomeDeliveryMasters.path,
        masterId,
        FirestorePaths.WelcomeDeliveryMasters.DeliveredUsers.path
      ),
      async () => {
        try {
          const aggregateSnapshot = await FS.getAggregateFromServer(
            FS.collection(
              firestore,
              FirestorePaths.WelcomeDeliveryMasters.path,
              masterId,
              FirestorePaths.WelcomeDeliveryMasters.DeliveredUsers.path
            ),
            { count: FS.count() }
          )
          setData(aggregateSnapshot.data().count)
        } catch (error) {
          console.error(error)
          setData(null)
        }
      }
    )

    return () => unsubscribe()
  }, [firestore, masterId])

  return data
}

/**
 * 配信済みユーザーIDをストリーム取得（CSV生成用）
 */
export async function* streamWelcomeDeliveryUserIds(
  firestore: FS.Firestore,
  masterId: string
): AsyncGenerator<string[], void, undefined> {
  const deliveredUsersRef = FS.collection(
    firestore,
    FirestorePaths.WelcomeDeliveryMasters.path,
    masterId,
    FirestorePaths.WelcomeDeliveryMasters.DeliveredUsers.path
  )

  const snapshot = await FS.getDocs(deliveredUsersRef)

  const batchSize = 100
  const userIds: string[] = []

  for (const doc of snapshot.docs) {
    userIds.push(doc.id)

    if (batchSize <= userIds.length) {
      yield [...userIds]
      userIds.length = 0
    }
  }

  if (0 < userIds.length) {
    yield userIds
  }
}

export function useUserPersonalNotifications(
  firestore: FS.Firestore,
  userId: UserId,
  limit?: number
): Loading<UserPersonalNotification[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.PersonalNotifications.getPath(userId),
    UserPersonalNotificationDocuments.fromDocumentSnapshot,
    limit,
    [FS.orderBy("created_at", "desc")]
  )
}

export async function markPersonalNotificationAsRead(
  firestore: FS.Firestore,
  userId: UserId,
  notificationId: PersonalNotificationId
): Promise<void> {
  await FS.updateDoc(
    FS.doc(firestore, `${FirestorePaths.Users.PersonalNotifications.getPath(userId)}/${notificationId}`),
    {
      is_read: true,
      read_at: FS.serverTimestamp(),
    }
  )
}

export function useUnreadPersonalNotificationCount(
  firestore: FS.Firestore,
  userId: UserId
): Loading<number> {
  const [result, setResult] = useState<Loading<number>>("loading")

  useEffect(() => {
    const query = FS.query(
      FS.collection(firestore, FirestorePaths.Users.PersonalNotifications.getPath(userId)),
      FS.where("is_read", "==", false)
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        setResult(snapshot.size)
      },
      (error) => {
        console.error("Error in useUnreadPersonalNotificationCount:", error)
        setResult(0)
      }
    )

    return () => unsubscribe()
  }, [firestore, userId])

  return result
}

export function useMyStories(firestore: FS.Firestore, userId: UserId): Loading<StoryDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.Stories.getPath(userId),
    StoryDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useStoryTimelines(firestore: FS.Firestore, userId: UserId): Loading<StoryTimelineDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.UserPrivates.StoryTimeline.getPath(userId),
    StoryTimelineDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("has_unread", "desc"), FS.orderBy("last_created_at", "desc")]
  )
}

export function useStampCards(firestore: FS.Firestore): Loading<StampCardDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.StampCards.path,
    StampCardDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("priority", "desc"), FS.orderBy("created_at", "desc")]
  )
}

export type StampCardListingFilter = "active" | "all"

export function useStampCardsPage(
  firestore: FS.Firestore,
  pagePosition: PagePosition,
  listingFilter: StampCardListingFilter = "active"
): Loading<PageResult<StampCardDocument>> {
  const now = useMemo(() => Date.now(), [])
  
  const baseQuery = useMemo(() => {
    const collectionRef = FS.collection(firestore, FirestorePaths.StampCards.path)

    if (listingFilter === "active") {
      return FS.query(
        collectionRef,
        FS.where("claim_period.end_at", ">", now),
        FS.orderBy("claim_period.end_at", "asc")
      )
    }

    return FS.query(collectionRef, FS.orderBy("created_at", "desc"))
  }, [firestore, listingFilter, now])

  const getPivotDocRef = useCallback(
    (docId: string) => FS.doc(firestore, `${FirestorePaths.StampCards.path}/${docId}`),
    [firestore]
  )

  const converter = useCallback(
    (doc: DocumentSnapshotLike) => StampCardDocuments.fromDocumentSnapshot(doc),
    []
  )

  return useQueryPage(baseQuery, getPivotDocRef, converter, pagePosition)
}

export function useReadableStampCards(firestore: FS.Firestore): Loading<StampCardDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.StampCards.path,
    StampCardDocuments.fromDocumentSnapshot,
    undefined,
    [
      FS.where("status", "==", "public"),
      FS.where("active_period_state.active", "==", true)
    ]
  )
}

export function useStampCard(firestore: FS.Firestore, cardId: LoadingOption<StampCardId>): LoadingOption<StampCardDocument> {
  return useDocument(firestore, FirestorePaths.StampCards.path, cardId, StampCardDocuments.fromDocumentSnapshot)
}

export function useStampLanes(firestore: FS.Firestore, cardId: LoadingOption<StampCardId>): Loading<StampLaneDocument[]> {
  const [result, setResult] = useState<Loading<StampLaneDocument[]>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.StampCards.StampLanes.getPath(cardId)),
      FS.orderBy("created_at", "asc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(StampLaneDocuments.fromDocumentSnapshot)
          .filter((doc): doc is StampLaneDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useStampLanes:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId])

  return result
}

export function useStampLane(
  firestore: FS.Firestore,
  cardId: LoadingOption<StampCardId>,
  laneId: LoadingOption<StampLaneId>
): LoadingOption<StampLaneDocument> {
  const [result, setResult] = useState<LoadingOption<StampLaneDocument>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null || laneId === "loading" || laneId === null) {
      setResult("loading")
      return
    }

    const docRef = FS.doc(firestore, FirestorePaths.StampCards.StampLanes.getDocPath(cardId, laneId))

    const unsubscribe = FS.onSnapshot(
      docRef,
      (snapshot) => {
        const doc = StampLaneDocuments.fromDocumentSnapshot(snapshot)
        setResult(doc)
      },
      (error) => {
        console.error("Error in useStampLane:", error)
        setResult(null)
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId, laneId])

  return result
}

export function useStampLaneRewards(
  firestore: FS.Firestore,
  cardId: LoadingOption<StampCardId>,
  laneId: LoadingOption<StampLaneId>
): Loading<StampLaneRewardDocument[]> {
  const [result, setResult] = useState<Loading<StampLaneRewardDocument[]>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null || laneId === "loading" || laneId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.StampCards.StampLanes.StampLaneRewards.getPath(cardId, laneId)),
      FS.orderBy("threshold_stamps", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(StampLaneRewardDocuments.fromDocumentSnapshot)
          .filter((doc): doc is StampLaneRewardDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useStampLaneRewards:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId, laneId])

  return result
}

export function useStampLaneReward(
  firestore: FS.Firestore,
  cardId: LoadingOption<StampCardId>,
  laneId: LoadingOption<StampLaneId>,
  rewardId: LoadingOption<string>
): Loading<StampLaneRewardDocument | undefined> {
  const [result, setResult] = useState<Loading<StampLaneRewardDocument | undefined>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null || laneId === "loading" || laneId === null || rewardId === "loading" || rewardId === null) {
      setResult("loading")
      return
    }

    const docRef = FS.doc(firestore, FirestorePaths.StampCards.StampLanes.StampLaneRewards.getPath(cardId, laneId), rewardId)

    const unsubscribe = FS.onSnapshot(
      docRef,
      (snapshot) => {
        const doc = StampLaneRewardDocuments.fromDocumentSnapshot(snapshot)
        setResult(doc ?? undefined)
      },
      (error) => {
        console.error("Error in useStampLaneReward:", error)
        setResult(undefined)
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId, laneId, rewardId])

  return result
}

export function useStampMissions(firestore: FS.Firestore, cardId: LoadingOption<StampCardId>): Loading<StampMissionDocument[]> {
  const [result, setResult] = useState<Loading<StampMissionDocument[]>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.StampCards.StampMissions.getPath(cardId)),
      FS.orderBy("priority", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(StampMissionDocuments.fromDocumentSnapshot)
          .filter((doc): doc is StampMissionDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useStampMissions:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId])

  return result
}

export function useReadableStampMissions(firestore: FS.Firestore, cardId: LoadingOption<StampCardId>): Loading<StampMissionDocument[]> {
  const [result, setResult] = useState<Loading<StampMissionDocument[]>>("loading")

  useEffect(() => {
    if (cardId === "loading" || cardId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.StampCards.StampMissions.getPath(cardId)),
      FS.where("status", "==", "public")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(StampMissionDocuments.fromDocumentSnapshot)
          .filter((doc): doc is StampMissionDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useReadableStampMissions:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, cardId])

  return result
}

export function useSubscriptionPlansAll(firestore: FS.Firestore): Loading<SubscriptionPlanDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SubscriptionPlans.path,
    SubscriptionPlanDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSubscriptionPlan(firestore: FS.Firestore, id: SubscriptionPlanId): LoadingOption<SubscriptionPlanDocument> {
  return useDocument(firestore, FirestorePaths.SubscriptionPlans.path, id, SubscriptionPlanDocuments.fromDocumentSnapshot)
}

export function useSubscriptionProductsAll(firestore: FS.Firestore): Loading<SubscriptionProductDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SubscriptionProducts.path,
    SubscriptionProductDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSubscriptionProduct(firestore: FS.Firestore, id: SubscriptionProductId): LoadingOption<SubscriptionProductDocument> {
  return useDocument(firestore, FirestorePaths.SubscriptionProducts.path, id, SubscriptionProductDocuments.fromDocumentSnapshot)
}

export function useViolationReportsAll(firestore: FS.Firestore): Loading<ViolationReportDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.ViolationReports.path,
    ViolationReportDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useViolationReportsByStatus(firestore: FS.Firestore, status: ViolationReportStatus | null): Loading<ViolationReportDocument[]> {
  const [result, setResult] = useState<Loading<ViolationReportDocument[]>>("loading")

  useEffect(() => {
    const constraints: FS.QueryConstraint[] = []
    if (status !== null) {
      constraints.push(FS.where("status", "==", status))
    }
    constraints.push(FS.orderBy("created_at", "desc"))

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.ViolationReports.path),
      ...constraints
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(ViolationReportDocuments.fromDocumentSnapshot)
          .filter((doc): doc is ViolationReportDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useViolationReportsByStatus:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, status])

  return result
}

export function useViolationReportsByUserId(firestore: FS.Firestore, userId: LoadingOption<UserId>): Loading<ViolationReportDocument[]> {
  const [result, setResult] = useState<Loading<ViolationReportDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.ViolationReports.path),
      FS.where("user_id", "==", userId),
      FS.orderBy("created_at", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(ViolationReportDocuments.fromDocumentSnapshot)
          .filter((doc): doc is ViolationReportDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useViolationReportsByUserId:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId])

  return result
}

export function useViolationReport(firestore: FS.Firestore, id: ViolationReportId): LoadingOption<ViolationReportDocument> {
  return useDocument(firestore, FirestorePaths.ViolationReports.path, id, ViolationReportDocuments.fromDocumentSnapshot)
}

export function useUserStampCardStates(firestore: FS.Firestore, userId: LoadingOption<UserId>): Loading<UserStampCardStateDocument[]> {
  const [result, setResult] = useState<Loading<UserStampCardStateDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.UserPrivates.StampCardStates.getPath(userId))
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(UserStampCardStateDocuments.fromDocumentSnapshot)
          .filter((doc): doc is UserStampCardStateDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        const path = FirestorePaths.UserPrivates.StampCardStates.getPath(userId)
        console.error(`Error in useUserStampCardStates (path: ${path}):`, error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId])

  return result
}

export function useUserStampCardState(
  firestore: FS.Firestore,
  userId: LoadingOption<UserId>,
  cardId: LoadingOption<StampCardId>
): LoadingOption<UserStampCardStateDocument> {
  const [result, setResult] = useState<LoadingOption<UserStampCardStateDocument>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null || cardId === "loading" || cardId === null) {
      setResult("loading")
      return
    }

    const docRef = FS.doc(firestore, FirestorePaths.UserPrivates.StampCardStates.getDocPath(userId, cardId))

    const unsubscribe = FS.onSnapshot(
      docRef,
      (snapshot) => {
        const doc = UserStampCardStateDocuments.fromDocumentSnapshot(snapshot)
        setResult(doc)
      },
      (error) => {
        const path = FirestorePaths.UserPrivates.StampCardStates.getDocPath(userId, cardId)
        console.error(`Error in useUserStampCardState (path: ${path}):`, error)
        setResult(null)
      }
    )

    return () => unsubscribe()
  }, [firestore, userId, cardId])

  return result
}

export function useUserStampMissionProgresses(
  firestore: FS.Firestore,
  userId: LoadingOption<UserId>,
  cardId: LoadingOption<StampCardId>
): Loading<UserStampMissionProgressDocument[]> {
  const [result, setResult] = useState<Loading<UserStampMissionProgressDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null || cardId === "loading" || cardId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.getPath(userId, cardId))
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(UserStampMissionProgressDocuments.fromDocumentSnapshot)
          .filter((doc): doc is UserStampMissionProgressDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        const path = FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.getPath(userId, cardId)
        console.error(`Error in useUserStampMissionProgresses (path: ${path}):`, error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId, cardId])

  return result
}

export function useUserStampMissionDailyProgresses(
  firestore: FS.Firestore,
  userId: LoadingOption<UserId>,
  cardId: LoadingOption<StampCardId>,
  missionId: LoadingOption<StampMissionId>
): Loading<UserStampMissionDailyProgressDocument[]> {
  const [result, setResult] = useState<Loading<UserStampMissionDailyProgressDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null || cardId === "loading" || cardId === null || missionId === "loading" || missionId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.StampMissionDailyProgresses.getPath(userId, cardId, missionId)),
      FS.orderBy("day_start_at", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(UserStampMissionDailyProgressDocuments.fromDocumentSnapshot)
          .filter((doc): doc is UserStampMissionDailyProgressDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        const path = FirestorePaths.UserPrivates.StampCardStates.StampMissionProgresses.StampMissionDailyProgresses.getPath(userId, cardId, missionId)
        console.error(`Error in useUserStampMissionDailyProgresses (path: ${path}):`, error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId, cardId, missionId])

  return result
}

export function useUserStampRewardClaims(
  firestore: FS.Firestore,
  userId: LoadingOption<UserId>,
  cardId: LoadingOption<StampCardId>,
  laneId: LoadingOption<StampLaneId>
): Loading<UserStampRewardClaimDocument[]> {
  const [result, setResult] = useState<Loading<UserStampRewardClaimDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null || cardId === "loading" || cardId === null || laneId === "loading" || laneId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.UserPrivates.StampCardStates.StampLanes.StampRewardClaims.getPath(userId, cardId, laneId))
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(UserStampRewardClaimDocuments.fromDocumentSnapshot)
          .filter((doc): doc is UserStampRewardClaimDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        const path = FirestorePaths.UserPrivates.StampCardStates.StampLanes.StampRewardClaims.getPath(userId, cardId, laneId)
        console.error(`Error in useUserStampRewardClaims (path: ${path}):`, error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId, cardId, laneId])

  return result
}

export function useSubscriptionHistoriesByUserId(firestore: FS.Firestore, userId: UserId): Loading<SubscriptionHistoryDocument[]> {
  const [result, setResult] = useState<Loading<SubscriptionHistoryDocument[]>>("loading")

  useEffect(() => {
    const query = FS.query(
      FS.collection(firestore, FirestorePaths.SubscriptionHistories.path),
      FS.where("user_id", "==", userId),
      FS.orderBy("created_at", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(SubscriptionHistoryDocuments.fromDocumentSnapshot)
          .filter((doc): doc is SubscriptionHistoryDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useSubscriptionHistoriesByUserId:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, userId])

  return result
}

export function useSubscriptionItemGrantMastersAll(firestore: FS.Firestore): Loading<SubscriptionItemGrantMasterDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.SubscriptionItemGrantMasters.path,
    SubscriptionItemGrantMasterDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useSubscriptionItemGrantMaster(firestore: FS.Firestore, id: SubscriptionItemGrantMasterId): LoadingOption<SubscriptionItemGrantMasterDocument> {
  return useDocument(firestore, FirestorePaths.SubscriptionItemGrantMasters.path, id, SubscriptionItemGrantMasterDocuments.fromDocumentSnapshot)
}

export function useAdminOperationsPage(firestore: FS.Firestore, pagePosition: PagePosition): Loading<PageResult<AdminOperationDocument>> {
  return useCollectionPage(firestore, FirestorePaths.AdminOperations.path, AdminOperationDocuments.fromDocumentSnapshot, pagePosition)
}

export function useAdminOperationsByTarget(firestore: FS.Firestore, targetKind: string, targetValue: LoadingOption<string>): Loading<AdminOperationDocument[]> {
  const [result, setResult] = useState<Loading<AdminOperationDocument[]>>("loading")

  useEffect(() => {
    if (targetValue === "loading" || targetValue === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.AdminOperations.path),
      FS.where("target.kind", "==", targetKind),
      FS.where("target.value.id", "==", targetValue),
      FS.orderBy("created_at", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(AdminOperationDocuments.fromDocumentSnapshot)
          .filter((doc): doc is AdminOperationDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useAdminOperationsByTarget:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, targetKind, targetValue])

  return result
}

export function useAdminOperationsByTargetUserId(firestore: FS.Firestore, targetKind: string, userId: LoadingOption<string>): Loading<AdminOperationDocument[]> {
  const [result, setResult] = useState<Loading<AdminOperationDocument[]>>("loading")

  useEffect(() => {
    if (userId === "loading" || userId === null) {
      setResult("loading")
      return
    }

    const query = FS.query(
      FS.collection(firestore, FirestorePaths.AdminOperations.path),
      FS.where("target.kind", "==", targetKind),
      FS.where("target.value.user_id", "==", userId),
      FS.orderBy("created_at", "desc")
    )

    const unsubscribe = FS.onSnapshot(
      query,
      (snapshot) => {
        const docs = snapshot.docs
          .map(AdminOperationDocuments.fromDocumentSnapshot)
          .filter((doc): doc is AdminOperationDocument => doc !== null)
        setResult(docs)
      },
      (error) => {
        console.error("Error in useAdminOperationsByTargetUserId:", error)
        setResult([])
      }
    )

    return () => unsubscribe()
  }, [firestore, targetKind, userId])

  return result
}

export type LiveCommentSearchParams = {
  userId: string | null
  spaceKey: string | null
}

export type LiveCommentSearchResult = LiveCommentDocument & { _path: string[] }

export function useLiveCommentSearch(
  firestore: FS.Firestore,
  params: LiveCommentSearchParams,
  pagePosition: PagePosition,
): Loading<PageResult<LiveCommentSearchResult>> {
  const { userId, spaceKey } = params
  const hasUserId = userId !== null && userId !== ""
  const hasSpaceKey = spaceKey !== null && spaceKey !== ""

  // --- ユーザーID指定: collection group カーソルベースページネーション ---
  const [userIdPageResult, setUserIdPageResult] = useState<Loading<PageResult<LiveCommentSearchResult>>>("loading")

  useEffect(() => {
    if (!hasUserId) {
      setUserIdPageResult({ docs: [] })
      return
    }

    let cancelled = false
    setUserIdPageResult("loading")

    const fetchPage = async () => {
      try {
        const baseQuery = liveCommentsByUserQuery(firestore, userId as UserId)

        // カーソルドキュメントの解決（フルパスを使用）
        const cursorPath = pagePosition.start ?? pagePosition.until
        let pivotDoc: FS.DocumentSnapshot | null = null
        if (cursorPath) {
          const doc = await FS.getDoc(FS.doc(firestore, cursorPath))
          if (doc.exists()) pivotDoc = doc
        }

        const cursorConstraints: FS.QueryConstraint[] = []
        if (pivotDoc) {
          if (pagePosition.until) {
            cursorConstraints.push(FS.endBefore(pivotDoc), FS.limitToLast(pagePosition.pageSize + 1))
          } else {
            cursorConstraints.push(FS.startAt(pivotDoc), FS.limit(pagePosition.pageSize + 1))
          }
        } else {
          cursorConstraints.push(FS.limit(pagePosition.pageSize + 1))
        }

        const q = FS.query(baseQuery, ...cursorConstraints)
        const snapshot = await FS.getDocs(q)

        if (cancelled) return

        const mapped = snapshot.docs.map((doc) => {
          const value = LiveCommentDocuments.fromDocumentSnapshot(doc)
          if (value === null) return null
          return { result: { ...value, _path: doc.ref.path.split("/") } as LiveCommentSearchResult, refPath: doc.ref.path }
        }).filter((d): d is NonNullable<typeof d> => d !== null)

        // スペースIDが指定されている場合はパスからフィルタ
        let filtered = mapped
        if (hasSpaceKey) {
          filtered = mapped.filter((d) => {
            const idx = d.result._path.indexOf("spaces")
            return 0 <= idx && d.result._path[idx + 1] === spaceKey
          })
        }

        if (pivotDoc && pagePosition.until) {
          setUserIdPageResult({
            docs: filtered.slice(-pagePosition.pageSize).map((d) => d.result),
            next: pagePosition.until,
            prev: filtered.length === pagePosition.pageSize + 1 && 2 <= filtered.length ? filtered[1].refPath : undefined,
          })
        } else {
          setUserIdPageResult({
            docs: filtered.slice(0, pagePosition.pageSize).map((d) => d.result),
            next: filtered.length === pagePosition.pageSize + 1 ? filtered[filtered.length - 1].refPath : undefined,
            prev: pagePosition.start,
          })
        }
      } catch (error) {
        console.error("Error in useLiveCommentSearch:", error)
        if (!cancelled) setUserIdPageResult({ docs: [] })
      }
    }

    void fetchPage()
    return () => { cancelled = true }
  }, [firestore, userId, spaceKey, hasUserId, hasSpaceKey, pagePosition.pageSize, pagePosition.start, pagePosition.until])

  // --- スペースIDのみ指定: 全件取得→クライアント側ページネーション ---
  const [spaceKeyAllDocs, setSpaceKeyAllDocs] = useState<LiveCommentSearchResult[]>([])
  const [spaceKeyLoading, setSpaceKeyLoading] = useState(false)

  useEffect(() => {
    if (hasUserId || !hasSpaceKey) {
      setSpaceKeyAllDocs([])
      setSpaceKeyLoading(false)
      return
    }

    let cancelled = false
    setSpaceKeyLoading(true)

    const fetchCommentsBySpaceKey = async () => {
      try {
        const livesPath = FirestorePaths.Spaces.Lives.getPath(SpaceKey(spaceKey as string))
        const livesSnapshot = await FS.getDocs(
          FS.query(FS.collection(firestore, livesPath)),
        )

        const allDocs: LiveCommentSearchResult[] = []
        for (const liveDoc of livesSnapshot.docs) {
          if (cancelled) return
          const commentsPath = FirestorePaths.Spaces.Lives.LiveComments.getPath(
            SpaceKey(spaceKey as string),
            LiveId(liveDoc.id),
          )
          const commentsSnapshot = await FS.getDocs(
            FS.query(
              FS.collection(firestore, commentsPath),
              FS.orderBy("created_at", "desc"),
            ),
          )
          for (const commentDoc of commentsSnapshot.docs) {
            const value = LiveCommentDocuments.fromDocumentSnapshot(commentDoc)
            if (value !== null) {
              allDocs.push({ ...value, _path: commentDoc.ref.path.split("/") })
            }
          }
        }

        if (!cancelled) {
          allDocs.sort((a, b) => b.created_at - a.created_at)
          setSpaceKeyAllDocs(allDocs)
          setSpaceKeyLoading(false)
        }
      } catch (error) {
        console.error("Error in useLiveCommentSearch (spaceKey):", error)
        if (!cancelled) {
          setSpaceKeyAllDocs([])
          setSpaceKeyLoading(false)
        }
      }
    }

    void fetchCommentsBySpaceKey()
    return () => { cancelled = true }
  }, [firestore, userId, spaceKey, hasUserId, hasSpaceKey])

  // スペースID検索結果のクライアント側ページネーション
  const spaceKeyPageResult = useMemo<Loading<PageResult<LiveCommentSearchResult>>>(() => {
    if (hasUserId || !hasSpaceKey) return { docs: [] }
    if (spaceKeyLoading) return "loading"
    if (spaceKeyAllDocs.length === 0) return { docs: [] }

    let startIndex = 0
    if (pagePosition.start) {
      const idx = parseInt(pagePosition.start, 10)
      if (!isNaN(idx)) startIndex = idx
    }
    if (pagePosition.until) {
      const idx = parseInt(pagePosition.until, 10)
      if (!isNaN(idx)) startIndex = Math.max(0, idx - pagePosition.pageSize)
    }

    const endIndex = Math.min(startIndex + pagePosition.pageSize, spaceKeyAllDocs.length)
    return {
      docs: spaceKeyAllDocs.slice(startIndex, endIndex),
      next: endIndex < spaceKeyAllDocs.length ? String(endIndex) : undefined,
      prev: 0 < startIndex ? String(startIndex) : undefined,
    }
  }, [hasUserId, hasSpaceKey, spaceKeyLoading, spaceKeyAllDocs, pagePosition.pageSize, pagePosition.start, pagePosition.until])

  if (!hasUserId && !hasSpaceKey) return { docs: [] }
  if (hasUserId) return userIdPageResult
  return spaceKeyPageResult
}

export type SelectionParticipantSearchResult = SelectionParticipantNominateDocument & { _path: string[] }

export function useSelectionParticipantSearch(
  firestore: FS.Firestore,
  params: LiveCommentSearchParams,
  pagePosition: PagePosition,
): Loading<PageResult<SelectionParticipantSearchResult>> {
  const { userId, spaceKey } = params
  const hasUserId = userId !== null && userId !== ""
  const hasSpaceKey = spaceKey !== null && spaceKey !== ""

  // --- ユーザーID指定: collection group カーソルベースページネーション ---
  const [userIdPageResult, setUserIdPageResult] = useState<Loading<PageResult<SelectionParticipantSearchResult>>>("loading")

  useEffect(() => {
    if (!hasUserId) {
      setUserIdPageResult({ docs: [] })
      return
    }

    let cancelled = false
    setUserIdPageResult("loading")

    const fetchPage = async () => {
      try {
        const baseQuery = selectionParticipantSearchByUserQuery(firestore, userId as UserId)

        const cursorPath = pagePosition.start ?? pagePosition.until
        let pivotDoc: FS.DocumentSnapshot | null = null
        if (cursorPath) {
          const doc = await FS.getDoc(FS.doc(firestore, cursorPath))
          if (doc.exists()) pivotDoc = doc
        }

        const cursorConstraints: FS.QueryConstraint[] = []
        if (pivotDoc) {
          if (pagePosition.until) {
            cursorConstraints.push(FS.endBefore(pivotDoc), FS.limitToLast(pagePosition.pageSize + 1))
          } else {
            cursorConstraints.push(FS.startAt(pivotDoc), FS.limit(pagePosition.pageSize + 1))
          }
        } else {
          cursorConstraints.push(FS.limit(pagePosition.pageSize + 1))
        }

        const q = FS.query(baseQuery, ...cursorConstraints)
        const snapshot = await FS.getDocs(q)

        if (cancelled) return

        const mapped = snapshot.docs.map((doc) => {
          const value = SelectionParticipantNominateDocuments.fromDocumentSnapshot(doc)
          if (value === null) return null
          return { result: { ...value, _path: doc.ref.path.split("/") } as SelectionParticipantSearchResult, refPath: doc.ref.path }
        }).filter((d): d is NonNullable<typeof d> => d !== null)

        let filtered = mapped
        if (hasSpaceKey) {
          filtered = mapped.filter((d) => {
            const idx = d.result._path.indexOf("spaces")
            return 0 <= idx && d.result._path[idx + 1] === spaceKey
          })
        }

        if (pivotDoc && pagePosition.until) {
          setUserIdPageResult({
            docs: filtered.slice(-pagePosition.pageSize).map((d) => d.result),
            next: pagePosition.until,
            prev: filtered.length === pagePosition.pageSize + 1 && 2 <= filtered.length ? filtered[1].refPath : undefined,
          })
        } else {
          setUserIdPageResult({
            docs: filtered.slice(0, pagePosition.pageSize).map((d) => d.result),
            next: filtered.length === pagePosition.pageSize + 1 ? filtered[filtered.length - 1].refPath : undefined,
            prev: pagePosition.start,
          })
        }
      } catch (error) {
        console.error("Error in useSelectionParticipantSearch:", error)
        if (!cancelled) setUserIdPageResult({ docs: [] })
      }
    }

    void fetchPage()
    return () => { cancelled = true }
  }, [firestore, userId, spaceKey, hasUserId, hasSpaceKey, pagePosition.pageSize, pagePosition.start, pagePosition.until])

  // --- スペースIDのみ指定: 全件取得→クライアント側ページネーション ---
  const [spaceKeyAllDocs, setSpaceKeyAllDocs] = useState<SelectionParticipantSearchResult[]>([])
  const [spaceKeyLoading, setSpaceKeyLoading] = useState(false)

  useEffect(() => {
    if (hasUserId || !hasSpaceKey) {
      setSpaceKeyAllDocs([])
      setSpaceKeyLoading(false)
      return
    }

    let cancelled = false
    setSpaceKeyLoading(true)

    const fetchParticipantsBySpaceKey = async () => {
      try {
        const livesPath = FirestorePaths.Spaces.Lives.getPath(SpaceKey(spaceKey as string))
        const livesSnapshot = await FS.getDocs(
          FS.query(FS.collection(firestore, livesPath)),
        )

        const allDocs: SelectionParticipantSearchResult[] = []
        for (const liveDoc of livesSnapshot.docs) {
          if (cancelled) return
          const selectionsPath = FirestorePaths.Spaces.Lives.Selections.getPath(
            SpaceKey(spaceKey as string),
            LiveId(liveDoc.id),
          )
          const selectionsSnapshot = await FS.getDocs(
            FS.query(FS.collection(firestore, selectionsPath)),
          )
          for (const selectionDoc of selectionsSnapshot.docs) {
            if (cancelled) return
            const participantsPath = FirestorePaths.Spaces.Lives.Selections.SelectionParticipants.getPath(
              SpaceKey(spaceKey as string),
              LiveId(liveDoc.id),
              SelectionId(selectionDoc.id),
            )
            const participantsSnapshot = await FS.getDocs(
              FS.query(
                FS.collection(firestore, participantsPath),
                FS.orderBy("created_at", "desc"),
              ),
            )
            for (const participantDoc of participantsSnapshot.docs) {
              const value = SelectionParticipantNominateDocuments.fromDocumentSnapshot(participantDoc)
              if (value !== null) {
                allDocs.push({ ...value, _path: participantDoc.ref.path.split("/") })
              }
            }
          }
        }

        if (!cancelled) {
          allDocs.sort((a, b) => b.created_at - a.created_at)
          setSpaceKeyAllDocs(allDocs)
          setSpaceKeyLoading(false)
        }
      } catch (error) {
        console.error("Error in useSelectionParticipantSearch (spaceKey):", error)
        if (!cancelled) {
          setSpaceKeyAllDocs([])
          setSpaceKeyLoading(false)
        }
      }
    }

    void fetchParticipantsBySpaceKey()
    return () => { cancelled = true }
  }, [firestore, userId, spaceKey, hasUserId, hasSpaceKey])

  const spaceKeyPageResult = useMemo<Loading<PageResult<SelectionParticipantSearchResult>>>(() => {
    if (hasUserId || !hasSpaceKey) return { docs: [] }
    if (spaceKeyLoading) return "loading"
    if (spaceKeyAllDocs.length === 0) return { docs: [] }

    let startIndex = 0
    if (pagePosition.start) {
      const idx = parseInt(pagePosition.start, 10)
      if (!isNaN(idx)) startIndex = idx
    }
    if (pagePosition.until) {
      const idx = parseInt(pagePosition.until, 10)
      if (!isNaN(idx)) startIndex = Math.max(0, idx - pagePosition.pageSize)
    }

    const endIndex = Math.min(startIndex + pagePosition.pageSize, spaceKeyAllDocs.length)
    return {
      docs: spaceKeyAllDocs.slice(startIndex, endIndex),
      next: endIndex < spaceKeyAllDocs.length ? String(endIndex) : undefined,
      prev: 0 < startIndex ? String(startIndex) : undefined,
    }
  }, [hasUserId, hasSpaceKey, spaceKeyLoading, spaceKeyAllDocs, pagePosition.pageSize, pagePosition.start, pagePosition.until])

  if (!hasUserId && !hasSpaceKey) return { docs: [] }
  if (hasUserId) return userIdPageResult
  return spaceKeyPageResult
}

// ─── Voice ──────────────────────────────────────────────────────────────────

export function useMyVoices(firestore: FS.Firestore, userId: UserId): Loading<VoiceDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.Voices.getPath(userId),
    VoiceDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useVoiceTimelines(firestore: FS.Firestore, userId: UserId): Loading<UserVoiceTimelineDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.UserPrivates.VoiceTimeline.getPath(userId),
    UserVoiceTimelineDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useUserFavorites(firestore: FS.Firestore, userId: UserId): Loading<UserFavoriteDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.UserPrivates.UserFavorites.getPath(userId),
    UserFavoriteDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useGlobalVoices(firestore: FS.Firestore): Loading<(VoiceDocument & { _path: string[] })[]> {
  return useCollectionGroupFromQuery(globalVoicesQuery(firestore, 50), FirestorePaths.Users.Voices.path, VoiceDocuments.fromDocumentSnapshot)
}

export function useVoiceReplies(firestore: FS.Firestore, userId: UserId, voiceId: VoiceId): Loading<VoiceReplyDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.Voices.VoiceReplies.getPath(userId, voiceId),
    VoiceReplyDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useVoiceEmotes(firestore: FS.Firestore, userId: UserId, voiceId: VoiceId): Loading<VoiceEmoteDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.Voices.VoiceEmotes.getPath(userId, voiceId),
    VoiceEmoteDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}

export function useVoiceReplyEmotes(firestore: FS.Firestore, userId: UserId, voiceId: VoiceId, replyId: VoiceReplyId): Loading<VoiceReplyEmoteDocument[]> {
  return useCollection(
    firestore,
    FirestorePaths.Users.Voices.VoiceReplies.VoiceReplyEmotes.getPath(userId, voiceId, replyId),
    VoiceReplyEmoteDocuments.fromDocumentSnapshot,
    undefined,
    [FS.orderBy("created_at", "desc")]
  )
}
